import { DateKeyString } from '../model/time-tracking/date-keys/types';
import { IndustryCode } from '../model/industries/types';
import { IndustryName } from '../model/industries/types';
import { ONetSocCode } from '../model/occupations/types';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  /** A time tracking date key which represents a specific day or month without time considerations. This key is not validated based on the time schedule since the schedule is unknown in this context. */
  DateKey: { input: DateKeyString; output: DateKeyString; }
  /** The date of birth of a user. */
  DateOfBirth: { input: Date; output: string; }
  /** A date-time string at UTC, such as 2007-12-03T10:15:30Z, compliant with the `date-time` format outlined in section 5.6 of the RFC 3339 profile of the ISO 8601 standard for representation of dates and times using the Gregorian calendar. */
  DateTime: { input: any; output: any; }
  /** A fixed-precision decimal value, transported as a string. String inputs are preferred; numeric inputs are accepted but may have already lost precision on the client. Scientific notation is rejected. */
  Decimal: { input: any; output: any; }
  /** A field whose value conforms to the standard internet email address format as specified in HTML Spec: https://html.spec.whatwg.org/multipage/input.html#valid-e-mail-address. */
  EmailAddress: { input: string; output: string; }
  IndustryCode: { input: IndustryCode; output: IndustryCode; }
  IndustryName: { input: IndustryName; output: IndustryName; }
  /** The `JSON` scalar type represents JSON values as specified by [ECMA-404](http://www.ecma-international.org/publications/files/ECMA-ST/ECMA-404.pdf). */
  JSON: { input: any; output: any; }
  /** A scalar that ensures that the provided skill name string with surrounding whitespace removed is not empty but also less than a maximum length of 500 characters. */
  LongUserInputString: { input: any; output: any; }
  /** The minimum number of successful attempts for a skill. */
  MinimumSuccessfulAttempts: { input: number; output: number; }
  /** A string that cannot be passed as an empty value */
  NonEmptyString: { input: any; output: any; }
  /** A scalar that represents a valid O*NET-SOC occupation code. */
  OccupationCode: { input: ONetSocCode; output: ONetSocCode; }
  /** A field whose value conforms to the standard E.164 format as specified in: https://en.wikipedia.org/wiki/E.164. Basically this is +17895551234. */
  PhoneNumber: { input: any; output: any; }
  /** A positive integer, excluding zero. */
  PositiveInteger: { input: number; output: number; }
  /** The name of a program time item. */
  ProgramTimeItemName: { input: string; output: string; }
  /** A scalar that converts strings with only whitespace into null values. */
  SanitizedString: { input: string | null; output: string | null; }
  /** A scalar that ensures that provided strings are trimmed and treated as 'null' in the case that they are empty, but also enforces that the string does not exceed a standard maximum length of 184 characters. */
  StandardOptionalUserInputString: { input: string | null; output: string | null; }
  /** A scalar that ensures that the provided string with surrounding whitespace removed is not empty but also less than a standard maximum length of 184 characters. */
  StandardUserInputString: { input: string; output: string; }
  /** The target score configured for a program with observation tracking. */
  TargetScore: { input: number; output: number; }
  /** A non empty string that is trimmed for whitespace. */
  TrimmedNonEmptyString: { input: string; output: string; }
  /** Rapids ID custom scalar type */
  rapidsId: { input: any; output: any; }
};

export type Absence = {
  __typename?: 'Absence';
  appUser?: Maybe<AppUser>;
  appUserId: Scalars['String']['output'];
  comment?: Maybe<Scalars['String']['output']>;
  /** Date the absence record was created */
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  /** Date of the absence */
  date?: Maybe<Scalars['DateTime']['output']>;
  duration: AbsenceDuration;
  id: Scalars['ID']['output'];
  /** Whether the absence can be edited or deleted (within 24 hours of creation) */
  isEditable?: Maybe<Scalars['Boolean']['output']>;
  program?: Maybe<Program>;
  programId: Scalars['String']['output'];
  reason: AbsenceReason;
  /** Date the absence record was last updated */
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

/** Duration of an absence */
export enum AbsenceDuration {
  FullDay = 'FULL_DAY',
  HalfDayAm = 'HALF_DAY_AM',
  HalfDayPm = 'HALF_DAY_PM'
}

/** Reason for an absence */
export enum AbsenceReason {
  Bereavement = 'BEREAVEMENT',
  ConferenceWorkshop = 'CONFERENCE_WORKSHOP',
  FamilyIllness = 'FAMILY_ILLNESS',
  JuryDuty = 'JURY_DUTY',
  Other = 'OTHER',
  PersonalBusiness = 'PERSONAL_BUSINESS',
  PersonalEmergency = 'PERSONAL_EMERGENCY',
  PersonalIllness = 'PERSONAL_ILLNESS'
}

/** Filters for admin absence reports */
export type AbsenceReportFilterBy = {
  learnerId?: InputMaybe<Scalars['ID']['input']>;
  programId?: InputMaybe<Scalars['ID']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
};

/** Sort parameters for absence reports */
export type AbsenceReportSortBy = {
  field: AbsenceReportSortField;
  order: AbsenceReportSortOrder;
};

/** Sortable fields for absence reports */
export enum AbsenceReportSortField {
  Comment = 'comment',
  Date = 'date',
  Duration = 'duration',
  FirstName = 'firstName',
  LastName = 'lastName',
  ProgramName = 'programName',
  Reason = 'reason'
}

/** Sort order for absence reports */
export enum AbsenceReportSortOrder {
  Asc = 'asc',
  Desc = 'desc'
}

export type Activity = {
  __typename?: 'Activity';
  activityRequirements: Array<ActivityRequirement>;
  /**
   * Returns the assigned activities for this activity.
   *         This is only available for admins.
   *         Covers the case where an admin is viewing a programs activities and wants to see the
   *         assigned activities for each activity. Sponsors see everyone in the collaborative and
   *         org admins only see their org's assigned activities.
   */
  assignedActivities: Array<AssignedActivity>;
  /** The LER credential associated with this activity */
  associatedCredential?: Maybe<AssociatedCredential>;
  /** Returns the associated RAP if exists. */
  associatedRap?: Maybe<RegisteredApprenticeshipProgram>;
  /** The average score of the ratings that have an associated target rating. */
  averageTargetRatingScore: Scalars['Float']['output'];
  /** The competency tags associated with this activity. */
  competencyTags: Array<ContentTag>;
  description?: Maybe<Scalars['String']['output']>;
  displayOrder: Scalars['Int']['output'];
  externalId?: Maybe<Scalars['String']['output']>;
  files: Array<ActivityFile>;
  id: Scalars['ID']['output'];
  /** Returns the parent level of the activity. */
  level: Level;
  links: Array<ActivityLink>;
  name: Scalars['String']['output'];
  /** The organization id that this activity belongs to. */
  organizationId: Scalars['ID']['output'];
  /** Returns the parent plan of the activity. */
  plan: Plan;
  planId: Scalars['String']['output'];
  /** Returns the parent program of the activity. */
  program: Program;
  /** Returns the required artifacts for this activity. */
  requirements: ActivityRequirementsMap;
  /** The rubric associated with this activity */
  rubric?: Maybe<Rubric>;
};

export type ActivityDateInput = {
  activityId: Scalars['String']['input'];
  dueDate: Scalars['DateTime']['input'];
  startDate: Scalars['DateTime']['input'];
};

export type ActivityFile = {
  __typename?: 'ActivityFile';
  createdAt: Scalars['DateTime']['output'];
  /** The user who uploaded this file. */
  createdBy: UserProfile;
  fileName: Scalars['String']['output'];
  filePath: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  mimeType: Scalars['String']['output'];
};

/** Filter options for an Activity record */
export type ActivityFilterBy = {
  name?: InputMaybe<Scalars['String']['input']>;
};

export type ActivityLink = {
  __typename?: 'ActivityLink';
  createdAt: Scalars['DateTime']['output'];
  /** The user who created this link. */
  createdBy: UserProfile;
  displayText: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  url: Scalars['String']['output'];
};

/** Sort options for an Activity record */
export type ActivityOrderBy = {
  name?: InputMaybe<SortOrder>;
};

export type ActivityRequirement = {
  __typename?: 'ActivityRequirement';
  activityId: Scalars['String']['output'];
  requiredArtifact: RequiredActivityArtifact;
  requirementAppliesTo: RequirementAppliesTo;
};

/**
 * Represents the status of an individual activity requirement.
 *     Used on the assigned activity object type.
 */
export type ActivityRequirementStatus = {
  __typename?: 'ActivityRequirementStatus';
  appliesTo: RequirementAppliesTo;
  artifact: RequiredActivityArtifact;
  satisfied: Scalars['Boolean']['output'];
};

export type ActivityRequirements = {
  __typename?: 'ActivityRequirements';
  evaluatingUserRequirements: Array<ActivityRequirementStatus>;
  learnerRequirements: Array<ActivityRequirementStatus>;
};

export type ActivityRequirementsMap = {
  __typename?: 'ActivityRequirementsMap';
  EVALUATING_USER: EvaluatorActivityRequirementsMap;
  LEARNER: LearnerActivityRequirementsMap;
};

/**
 * The collection of comments and ratings to be submitted alongside a review.
 *     When an activity evaluation is submitted, the corresponding review's state will change
 *     to PUBLISHED, and a connection to the newly created Submission is made.
 */
export type ActivityReview = {
  __typename?: 'ActivityReview';
  assignedActivity: AssignedActivity;
  assignedActivityId: Scalars['String']['output'];
  assignedActivitySubmission?: Maybe<AssignedActivitySubmission>;
  assignedActivitySubmissionId?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  /** Boolean indicating if all criterion in the rubric have been scored. */
  isFullyScored: Scalars['Boolean']['output'];
  /** Rubric that the scored criteria belong to, or null if there are no scored criteria. */
  rubric?: Maybe<Rubric>;
  scoredCriteria: Array<ScoredCriterion>;
  state: ActivityReviewState;
};

export enum ActivityReviewState {
  Draft = 'DRAFT',
  Submitted = 'SUBMITTED'
}

export enum ActivityStatus {
  Approved = 'APPROVED',
  Returned = 'RETURNED',
  Submitted = 'SUBMITTED',
  Unsubmitted = 'UNSUBMITTED'
}

/** Data to submit an activity. */
export type ActivitySubmissionData = {
  /** The user IDs of the preferred reviewers to assign to the submission. If provided when the status is not submitted, it will result in an error. */
  reviewerIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  score?: InputMaybe<Scalars['Int']['input']>;
  /** The new status used to update the assigned activity. */
  status: ActivityStatus;
};

/** Join betwen content tag and activity */
export type ActivityTag = {
  __typename?: 'ActivityTag';
  activity: Activity;
  activityId: Scalars['String']['output'];
  tag: ContentTag;
  tagId: Scalars['String']['output'];
};

export type AddSponsoredOrganizationInput = {
  name: Scalars['String']['input'];
  sponsorOrganizationId: Scalars['ID']['input'];
  type: AllowedOrganizationTypesToSponsor;
};

export type Address = {
  __typename?: 'Address';
  addressLine1: Scalars['String']['output'];
  addressLine2?: Maybe<Scalars['String']['output']>;
  city: Scalars['String']['output'];
  country: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  state: Scalars['String']['output'];
  zipCode: Scalars['String']['output'];
};

export type AddressInput = {
  addressLine1: Scalars['NonEmptyString']['input'];
  addressLine2?: InputMaybe<Scalars['NonEmptyString']['input']>;
  city: Scalars['NonEmptyString']['input'];
  state: Scalars['NonEmptyString']['input'];
  zipCode: Scalars['NonEmptyString']['input'];
};

/** An Edlink integration recorded against an organization. */
export type AdminEdlinkIntegration = {
  __typename?: 'AdminEdlinkIntegration';
  createdAt: Scalars['DateTime']['output'];
  /** The Edlink-issued id for the connection. */
  edlinkIntegrationId: Scalars['String']['output'];
  /** Identifier of the stored integration row, not the Edlink-issued id. */
  id: Scalars['ID']['output'];
  /** The source system's name as Edlink reports it, null until captured. */
  providerName?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
};

/** An organization together with its Edlink connection data, for administrator use. */
export type AdminEdlinkOrganization = {
  __typename?: 'AdminEdlinkOrganization';
  /** The in-progress Edlink onboarding id, null when no onboarding is outstanding. */
  edlinkOnboardingId?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  /** Every source the organization has connected, oldest first. An organization may hold several, such as a SIS and an LMS. */
  integrations: Array<AdminEdlinkIntegration>;
  name: Scalars['String']['output'];
  status: AdminEdlinkStatus;
  type: OrganizationType;
};

/** The Edlink connection state of an organization as presented by the system administrator tool. CONNECTED covers an organization holding any number of sources. */
export enum AdminEdlinkStatus {
  Connected = 'CONNECTED',
  NotConnected = 'NOT_CONNECTED',
  Pending = 'PENDING'
}

export type AdminEmailChangeRecord = {
  __typename?: 'AdminEmailChangeRecord';
  /** When the email change was committed. */
  changedAt: Scalars['DateTime']['output'];
  /** Email of the Craft admin who performed the change. */
  createdByEmail: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  /** The email the admin set on the user. */
  newEmail: Scalars['String']['output'];
  /** The email the user had before the admin changed it. */
  oldEmail: Scalars['String']['output'];
  /** The reason the admin entered when making the change. */
  reason: Scalars['String']['output'];
};

/** The one Edlink source to stop recording against an organization. */
export type AdminRemoveOrganizationEdlinkIntegrationInput = {
  /** The stored row to remove, as reported by `AdminEdlinkIntegration.id`. */
  integrationRowId: Scalars['String']['input'];
  organizationId: Scalars['ID']['input'];
};

/** One Edlink source to record against an organization, either added or edited in place. Sources the input does not name are left alone. */
export type AdminSaveOrganizationEdlinkIntegrationInput = {
  /** The Edlink-issued id for the connection. Clearing it is a removal, not a save. */
  edlinkIntegrationId?: InputMaybe<Scalars['StandardOptionalUserInputString']['input']>;
  /** The stored row to edit, as reported by `AdminEdlinkIntegration.id`. Omit it to add a source rather than change one, which is how an organization gains a second connection. */
  integrationRowId?: InputMaybe<Scalars['StandardOptionalUserInputString']['input']>;
  organizationId: Scalars['ID']['input'];
  /** The provider name to store. System administrators may set it manually to correct stored Edlink data. */
  providerName?: InputMaybe<Scalars['StandardOptionalUserInputString']['input']>;
};

/** The onboarding an organization has in flight, independent of the sources it holds. */
export type AdminUpdateOrganizationEdlinkOnboardingInput = {
  /** The in-progress Edlink onboarding id to record. Null clears it, which is how a stranded onboarding is cleaned up. */
  edlinkOnboardingId?: InputMaybe<Scalars['StandardOptionalUserInputString']['input']>;
  organizationId: Scalars['ID']['input'];
};

/** Filters for the admin user search query. */
export type AdminUserSearchFilters = {
  /** Search term matched against first name, last name, or email. */
  search?: InputMaybe<StringFilter>;
};

export type AdminUserSearchResult = {
  __typename?: 'AdminUserSearchResult';
  /** Edlink person ID when the account is LTI-linked, otherwise null. */
  edlinkPersonId?: Maybe<Scalars['String']['output']>;
  email: Scalars['String']['output'];
  firstName: Scalars['String']['output'];
  /** User's full name, computed from first and last name. */
  fullName: Scalars['String']['output'];
  id: Scalars['String']['output'];
  inactive: Scalars['Boolean']['output'];
  /** The reason the account was deactivated, when available. */
  inactiveReason?: Maybe<Scalars['String']['output']>;
  lastName: Scalars['String']['output'];
  /** Distinct organization names the user belongs to, alphabetised by the resolver. */
  organizationNames: Array<Scalars['String']['output']>;
};

/** The types of organizations that can be sponsored. Excludes the RAP Sponsor type. */
export enum AllowedOrganizationTypesToSponsor {
  EducationProvider = 'EDUCATION_PROVIDER',
  Employer = 'EMPLOYER'
}

export enum AppRole {
  Admin = 'ADMIN',
  Evaluator = 'EVALUATOR',
  Facilitator = 'FACILITATOR',
  Instructor = 'INSTRUCTOR',
  Learner = 'LEARNER',
  Observer = 'OBSERVER'
}

export type AppUser = {
  __typename?: 'AppUser';
  /** Evaluators assigned to this user */
  assignedEvaluators: Array<AppUser>;
  /** Learners assigned to this user in an evaluator capacity. */
  assignedLearners: Array<AppUser>;
  /** Programs assigned to this user, including RAP programs */
  assignedPrograms: Array<AssignedProgram>;
  /** The user's avatar, resolved server-side from their Gravatar. */
  avatar: Avatar;
  educationProvider?: Maybe<Organization>;
  /** The user's email address for the current organization. */
  email: Scalars['String']['output'];
  employer?: Maybe<Organization>;
  firstName: Scalars['String']['output'];
  /** User's full name */
  fullName: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  inactive: Scalars['Boolean']['output'];
  /** User first and last name initials. */
  initials: Scalars['String']['output'];
  /** The last time this user was invited. */
  invitedAt?: Maybe<Scalars['DateTime']['output']>;
  /** Returns true if the user is assigned to a plan */
  isAssignedToPlan: Scalars['Boolean']['output'];
  lastName: Scalars['String']['output'];
  /** The last time this user was invited. */
  lastSignIn?: Maybe<Scalars['DateTime']['output']>;
  middleName?: Maybe<Scalars['String']['output']>;
  /** Programs assigned to this user, not including RAP programs */
  organizationAssignedPrograms: Array<AssignedProgram>;
  organizationRoles: Array<OrganizationRole>;
  /** Organizations where the user has the provided role */
  organizationsWhereUserHasRole: Array<Organization>;
  /** RAP associated with the user via program assignment */
  registeredApprenticeshipProgram?: Maybe<RegisteredApprenticeshipProgram>;
  selectedOrganizationRole?: Maybe<OrganizationRole>;
  sponsor?: Maybe<Organization>;
  /** Tags assigned to the user. The list is filtered by the requesting user's organization. */
  tags: Array<UserTag>;
};


export type AppUserIsAssignedToPlanArgs = {
  where: IsAssignedToPlanWhereInput;
};


export type AppUserOrganizationAssignedProgramsArgs = {
  where: AssignedProgramOptionalWhereInput;
};


export type AppUserOrganizationsWhereUserHasRoleArgs = {
  role: AppRole;
};

export type AppUserEmail = {
  __typename?: 'AppUserEmail';
  email: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  /** Indicates if the email is associated with an organization. */
  isConnectedToAnOrganization: Scalars['Boolean']['output'];
  userId: Scalars['String']['output'];
  /** Datetime the email was verified. */
  verifiedAt?: Maybe<Scalars['DateTime']['output']>;
};

/** User phone number. */
export type AppUserPhoneNumber = {
  __typename?: 'AppUserPhoneNumber';
  id: Scalars['ID']['output'];
  phoneNumber: Scalars['String']['output'];
  user: AppUser;
  /** Tracks the date and time when the user verifies the associated phone number. */
  verifiedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type ApproveTimeEntryInput = {
  comment?: InputMaybe<Scalars['SanitizedString']['input']>;
};

export type AssignLearnersToProgramInput = {
  activityDates: Array<ActivityDateInput>;
  anticipatedEndDate: Scalars['DateTime']['input'];
  assignPlans: Scalars['Boolean']['input'];
  /** Level unlock dates for the assigned. Optional. Only needed if the program is set to lock levels */
  levelUnlockDates?: InputMaybe<Array<LevelLockInput>>;
  startDate: Scalars['DateTime']['input'];
};

/** Filters that can be used for querying assigned activities that are pending approval. */
export type AssignedActivitiesPendingApprovalFilters = {
  /** An array of learners to filter by. */
  learners: Array<Scalars['String']['input']>;
};

export type AssignedActivitiesPendingApprovalResponseMetadataType = {
  __typename?: 'AssignedActivitiesPendingApprovalResponseMetadataType';
  count: Scalars['Int']['output'];
  hasMoreResults: Scalars['Boolean']['output'];
};

export type AssignedActivitiesWithContentType = {
  __typename?: 'AssignedActivitiesWithContentType';
  /** The list of assigned activities with content */
  assignedActivityList: Array<AssignedActivity>;
  /** Indicates whether the assigned program can be deleted based on the status of the assigned activities contained in the assigned program. */
  deletionAllowed: Scalars['Boolean']['output'];
};

export type AssignedActivity = {
  __typename?: 'AssignedActivity';
  activity: Activity;
  activityFiles: Array<ActivityFile>;
  activityId: Scalars['String']['output'];
  activityLinks: Array<ActivityLink>;
  activityRequirements?: Maybe<ActivityRequirements>;
  assignedPlan: AssignedPlan;
  /** The assignedProgram this assignedActivity is associated with. */
  assignedProgram: AssignedProgram;
  /** The average score for the submission */
  averageScore?: Maybe<Scalars['Float']['output']>;
  /** The competency tags associated with this assigned activity. */
  competencyTags: Array<ContentTag>;
  /** The reviewers assigned to evaluate the latest submitted submission, ordered alphabetically by name and reconciled against the evaluators currently assigned to the learner so inactive or unassigned reviewers are excluded. Returns an empty list when no submission has been made or none of the recorded reviewers remain assigned. Throws if the activity is in a SUBMITTED state but no submitted submission exists, since that combination is contradictory data. */
  currentReviewers: Array<UserProfile>;
  /** The description of the plan. */
  description?: Maybe<Scalars['String']['output']>;
  /** The order used to display the plan in a list of other plans. */
  displayOrder: Scalars['Int']['output'];
  /** The due date of the assigned activity. */
  dueDate?: Maybe<Scalars['DateTime']['output']>;
  files: Array<AssignedActivityFile>;
  id: Scalars['ID']['output'];
  /** Whether or not the activity is unlocked for this learner. */
  isUnlocked: Scalars['Boolean']['output'];
  /** The latest user to have evaluated the assigned activity. */
  latestEvaluator?: Maybe<UserProfile>;
  /** The latest score for the assigned activity. Must be associated with a submission to be considered a valid score */
  latestScore?: Maybe<Scalars['Int']['output']>;
  /**
   * The learner associated with this assigned program.
   * @deprecated Use learner profile field instead
   */
  learner: UserProfile;
  learnerId: Scalars['String']['output'];
  /** The learner associated with this assigned activity. */
  learnerProfile: LearnerProfile;
  links: Array<AssignedActivityLink>;
  /** The name of the plan. */
  name: Scalars['String']['output'];
  /** Comment created by the viewing user which have has yet been associated with a submission. */
  pendingComment?: Maybe<AssignedActivityComment>;
  /** Files created by the viewing user which have not yet been associated with a submission */
  pendingFiles: Array<AssignedActivityFile>;
  /** Links created by the viewing user which have not yet been associated with a submission */
  pendingLinks: Array<AssignedActivityLink>;
  /** Observation date created by the viewing user which have has yet been associated with a submission. */
  pendingObservationDate?: Maybe<AssignedActivityObservationDate>;
  /** Review created by the viewing user which have has yet been associated with a submission. */
  pendingReview?: Maybe<ActivityReview>;
  /** The program this assignedActivity is associated with. */
  program: Program;
  /** The rubric associated with this assigned activity's activity */
  rubric?: Maybe<Rubric>;
  status: ActivityStatus;
  /** Returns the assignedActivity's submission history ordered newest to oldest. */
  submissionHistory: Array<AssignedActivitySubmission>;
  /** The time spent on the activity. Some users do not track this value. There for it can be undefined. */
  timeSpentOnActivity?: Maybe<TimeSpent>;
};

export type AssignedActivityComment = {
  __typename?: 'AssignedActivityComment';
  comment: Scalars['String']['output'];
  /** The user who created this comment. */
  createdBy: UserProfile;
  id: Scalars['ID']['output'];
};

export type AssignedActivityFile = {
  __typename?: 'AssignedActivityFile';
  /** True if this file is attached to a submission, false otherwise. */
  attachedToSubmission: Scalars['Boolean']['output'];
  createdAt: Scalars['DateTime']['output'];
  /** The user who uploaded this file. */
  createdBy: UserProfile;
  fileName: Scalars['String']['output'];
  filePath: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  mimeType: Scalars['String']['output'];
  submission?: Maybe<AssignedActivitySubmission>;
};

export type AssignedActivityFileDownload = {
  __typename?: 'AssignedActivityFileDownload';
  /** When the file was created */
  createdAt: Scalars['DateTime']['output'];
  downloadUrl: Scalars['String']['output'];
  fileName: Scalars['String']['output'];
  filePath: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  mimeType: Scalars['String']['output'];
};

export type AssignedActivityLink = {
  __typename?: 'AssignedActivityLink';
  /** True if this link is attached to a submission, false otherwise. */
  attachedToSubmission: Scalars['Boolean']['output'];
  createdAt: Scalars['DateTime']['output'];
  /** The user who created this link. */
  createdBy: UserProfile;
  displayText: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  submission?: Maybe<AssignedActivitySubmission>;
  url: Scalars['String']['output'];
};

/** Tracks the date at which a learner was observed doing an activity. */
export type AssignedActivityObservationDate = {
  __typename?: 'AssignedActivityObservationDate';
  id: Scalars['ID']['output'];
  /** The date of the observation. */
  observedAt: Scalars['DateTime']['output'];
};

/** Sort options for an AssignedActivity record */
export type AssignedActivityOrderBy = {
  dueDate?: InputMaybe<SortOrder>;
  learner?: InputMaybe<LearnerOrderBy>;
  status?: InputMaybe<SortOrder>;
  timeSpentOnActivity?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export enum AssignedActivityPendingApprovalSortFieldEnum {
  SubmittedAt = 'submittedAt'
}

export type AssignedActivityPendingApprovalSortOrderBy = {
  field: AssignedActivityPendingApprovalSortFieldEnum;
  sortOrder: SortOrder;
};

export type AssignedActivityScore = {
  __typename?: 'AssignedActivityScore';
  /** The user who created this score. */
  createdBy: UserProfile;
  id: Scalars['ID']['output'];
  value: Scalars['Int']['output'];
};

export enum AssignedActivitySortFieldEnum {
  DueDate = 'dueDate',
  Learner = 'learner',
  Status = 'status',
  TimeSpentOnActivity = 'timeSpentOnActivity',
  UpdatedAt = 'updatedAt'
}

export type AssignedActivitySortOrderBy = {
  field: AssignedActivitySortFieldEnum;
  sortOrder: SortOrder;
};

export type AssignedActivityStatusAggregate = {
  __typename?: 'AssignedActivityStatusAggregate';
  /** Aggregate count of all activity statuses */
  count: LearnerActivityStats;
  /** Aggregate percent of all activity statuses */
  percent: LearnerActivityStats;
  /** Aggregate timeSpent of all activity statuses */
  timeSpent: LearnerActivityStats;
};

export type AssignedActivitySubmission = {
  __typename?: 'AssignedActivitySubmission';
  comments: Array<AssignedActivityComment>;
  /** The due date of the assigned activity. */
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  /** The user who created this submission. */
  createdBy: UserProfile;
  files: Array<AssignedActivityFile>;
  id: Scalars['ID']['output'];
  links: Array<AssignedActivityLink>;
  /** The date at which the learner was observed doing the assigned activity. */
  observationDate?: Maybe<Scalars['DateTime']['output']>;
  review?: Maybe<ActivityReview>;
  /** The reviewers assigned to evaluate the submission, ordered alphabetically by name. */
  reviewers: Array<UserProfile>;
  score?: Maybe<AssignedActivityScore>;
  status: ActivityStatus;
};

export type AssignedCompetencyGroup = {
  __typename?: 'AssignedCompetencyGroup';
  /** Activity status counts for this assigned competency tag */
  activityStatus: AssignedActivityStatusAggregate;
  /** The ID of this competency group. */
  groupId: Scalars['ID']['output'];
  /** The name of this competency group. */
  name: Scalars['String']['output'];
  /** The tags that make up this group in the context of the assignedRap. */
  tags: Array<AssignedCompetencyTag>;
};

export type AssignedCompetencyTag = {
  __typename?: 'AssignedCompetencyTag';
  /** Activity status counts for this assigned competency tag */
  activityStatus: AssignedActivityStatusAggregate;
  /** The name of this competency group. */
  displayValue: Scalars['String']['output'];
  /** The ID of this competency tag. */
  tagId: Scalars['ID']['output'];
};

export type AssignedInstructor = {
  __typename?: 'AssignedInstructor';
  /** The learner associated with this assigned program. */
  instructor: UserProfile;
  instructorId: Scalars['String']['output'];
  plan: Plan;
  planId: Scalars['String']['output'];
};

export type AssignedLevel = {
  __typename?: 'AssignedLevel';
  /** Activity status counts for this assigned level */
  activityStatus: AssignedActivityStatusAggregate;
  /** Assigned plans related to this assigned level. Ordered by plan display order */
  assignedPlans: Array<AssignedPlan>;
  assignedProgram: AssignedProgram;
  /** The description of the level */
  description?: Maybe<Scalars['String']['output']>;
  /** The order used to display the level in a list of other levels */
  displayOrder: Scalars['Int']['output'];
  /** The earliest start date of all activities in the level, representing in our case the start date of the level */
  earliestActivityStartDate?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  isUnlocked: Scalars['Boolean']['output'];
  /** The latest due date of all activities in the level, representing in our case the due date of the level */
  latestActivityDueDate?: Maybe<Scalars['String']['output']>;
  learner: AppUser;
  /** The learner associated with this assigned level. */
  learnerProfile: LearnerProfile;
  levelId: Scalars['String']['output'];
  levelLockSettingEnabled: Scalars['Boolean']['output'];
  /** The name of the level */
  name: Scalars['String']['output'];
  plansCount: Scalars['Int']['output'];
  /** The time spent on the level. Aggregated from approved activities. */
  timeSpentOnLevel?: Maybe<TimeSpent>;
  unlockOn?: Maybe<Scalars['String']['output']>;
};

export enum AssignedLevelSortFieldEnum {
  Learner = 'learner',
  Status = 'status',
  UnlockDate = 'unlockDate'
}

export type AssignedLevelSortOrderBy = {
  field: AssignedLevelSortFieldEnum;
  sortOrder: SortOrder;
};

export type AssignedPlan = {
  __typename?: 'AssignedPlan';
  activitiesCount: Scalars['Int']['output'];
  /** Activity status counts for this assigned plan */
  activityStatus: AssignedActivityStatusAggregate;
  /** Assigned activities related to this assigned plan. Ordered by activity display order */
  assignedActivities: Array<AssignedActivity>;
  /** The assigned activities that have associated content. */
  assignedActivitiesWithContent: AssignedActivitiesWithContentType;
  assignedLevel: AssignedLevel;
  /** The assigned program associated with this assigned plan. */
  assignedProgram: AssignedProgram;
  /** The description of the plan. */
  description?: Maybe<Scalars['String']['output']>;
  /** The order used to display the plan in a list of other plans. */
  displayOrder: Scalars['Int']['output'];
  /** The earliest start date of all activities in the plan, representing in our case the start date of the plan */
  earliestActivityStartDate?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  /** Is the parent level unlocked */
  isUnlocked: Scalars['Boolean']['output'];
  /** The latest due date of all activities in the plan, representing in our case the due date of the plan */
  latestActivityDueDate?: Maybe<Scalars['String']['output']>;
  /** The learner associated with this assigned program. */
  learner: UserProfile;
  /** The learner associated with this assigned plan. */
  learnerProfile: LearnerProfile;
  /** The name of the plan. */
  name: Scalars['String']['output'];
  planId: Scalars['String']['output'];
  /** The time spent on the plan. Aggregated from approved activities. */
  timeSpentOnPlan?: Maybe<TimeSpent>;
};


export type AssignedPlanAssignedActivitiesArgs = {
  orderBy?: InputMaybe<AssignedActivityOrderBy>;
};

export type AssignedPlanDeletionStatus = {
  __typename?: 'AssignedPlanDeletionStatus';
  id: Scalars['String']['output'];
  learnerProfile: LearnerProfile;
};

export enum AssignedPlanSortFieldEnum {
  Learner = 'learner',
  Status = 'status'
}

export type AssignedPlanSortOrderBy = {
  field: AssignedPlanSortFieldEnum;
  sortOrder: SortOrder;
};

export type AssignedProgram = {
  __typename?: 'AssignedProgram';
  /** Activity status counts for this assigned program */
  activityStatus: AssignedActivityStatusAggregate;
  /** The anticipated end date of the assigned program. */
  anticipatedEndDate?: Maybe<Scalars['DateTime']['output']>;
  /** Activities in the assigned program which have the given tag applied. */
  assignedActivitiesWithAppliedTag: Array<AssignedActivity>;
  /** The assigned activities that have associated content. */
  assignedActivitiesWithContent: AssignedActivitiesWithContentType;
  /** The number of assigned activities nested inside the assigned program. */
  assignedActivityCount: Scalars['Int']['output'];
  /** The number of assigned levels inside the assigned program. */
  assignedLevelCount: Scalars['Int']['output'];
  /** Assigned levels related to this assigned program. Ordered by level display order */
  assignedLevels: Array<AssignedLevel>;
  /** The number of assigned plans nested inside the assigned program. */
  assignedPlanCount: Scalars['Int']['output'];
  createdAt: Scalars['DateTime']['output'];
  /** The description of the program */
  description?: Maybe<Scalars['String']['output']>;
  /** The order used to display the program in a list of other programs */
  displayOrder: Scalars['Int']['output'];
  /** Timestamp of the first activity (comment, file, link, or submission) */
  firstLearnerActivityAt?: Maybe<Scalars['DateTime']['output']>;
  history: Array<AssignedProgramHistory>;
  id: Scalars['ID']['output'];
  /** Timestamp of the most recent activity approval submission */
  lastActivityApprovedAt?: Maybe<Scalars['DateTime']['output']>;
  /**
   * The learner associated with this assigned program.
   * @deprecated Use learner profile field instead
   */
  learner: UserProfile;
  learnerId: Scalars['String']['output'];
  /** The learner associated with this assigned program. */
  learnerProfile: LearnerProfile;
  levelsCount: Scalars['Int']['output'];
  /** The name of the program */
  name: Scalars['String']['output'];
  /** Observation tracking information for the program and learner associated with this assigned program. Will be null if the program is not configured for observation tracking. */
  observationTracking?: Maybe<LearnerProgramObservationTracking>;
  /** The name of the organization that owns the program. */
  organizationName: Scalars['String']['output'];
  /** The program associated with this assigned program. */
  program: Program;
  programId: Scalars['String']['output'];
  /** Computed status based on activity completion and dates (Active/Completed/Withdrawn) */
  programStatus: AssignedProgramStatus;
  /** The start date of the assigned program. */
  startDate?: Maybe<Scalars['DateTime']['output']>;
  /** The state of the program. Possible values are ProgramState enum. */
  state: ProgramState;
  status: AssignedProgramStatus;
  /** The amount of time the learner has spent on the program. Aggregation of approved time spent on activities. */
  timeSpentOnProgram?: Maybe<TimeSpent>;
  /** Time tracking information for the program and learner associated with this assigned program. Will be null if the program is not configured for time tracking. */
  trackedTime?: Maybe<LearnerProgramTrackedTime>;
};


export type AssignedProgramAssignedActivitiesWithAppliedTagArgs = {
  tagId: Scalars['ID']['input'];
};

export type AssignedProgramDeletionStatus = {
  __typename?: 'AssignedProgramDeletionStatus';
  id: Scalars['String']['output'];
  learnerProfile: LearnerProfile;
};

export type AssignedProgramFilter = {
  every?: InputMaybe<AssignedProgramWhereInput>;
  none?: InputMaybe<AssignedProgramWhereInput>;
  some?: InputMaybe<AssignedProgramWhereInput>;
};

export type AssignedProgramHistory = {
  __typename?: 'AssignedProgramHistory';
  assignedProgramId: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  statusFrom?: Maybe<AssignedProgramStatus>;
  statusTo: AssignedProgramStatus;
  /** The user who made this status change */
  updatedBy: UserProfile;
};

export type AssignedProgramOptionalWhereInput = {
  organizationId: Scalars['ID']['input'];
};

export type AssignedProgramOrderBy = {
  name?: InputMaybe<SortOrder>;
};

export enum AssignedProgramSortFieldEnum {
  EndDate = 'endDate',
  Learner = 'learner',
  StartDate = 'startDate',
  Status = 'status'
}

export type AssignedProgramSortOrderBy = {
  field: AssignedProgramSortFieldEnum;
  sortOrder: SortOrder;
};

export enum AssignedProgramStatus {
  Active = 'ACTIVE',
  Assigned = 'ASSIGNED',
  Completed = 'COMPLETED',
  Withdrawn = 'WITHDRAWN'
}

export type AssignedProgramWhereInput = {
  AND?: InputMaybe<Array<AssignedProgramWhereInput>>;
  NOT?: InputMaybe<Array<AssignedProgramWhereInput>>;
  OR?: InputMaybe<Array<AssignedProgramWhereInput>>;
  learner?: InputMaybe<UserWhereInput>;
  learnerId?: InputMaybe<StringFilter>;
  program?: InputMaybe<ProgramWhereInput>;
  programId?: InputMaybe<StringFilter>;
};

export type AssignedRap = {
  __typename?: 'AssignedRap';
  /** Activity status counts for this assigned competency tag */
  activityStatus: AssignedActivityStatusAggregate;
  /** The competency tag groups associated with this assigned RAP. */
  competencyGroups: Array<AssignedCompetencyGroup>;
  /** Competency tags associated with this assigned RAP. */
  competencyTags: Array<AssignedCompetencyTag>;
  /** The anticipated end date of the assigned RAP. */
  endDate?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  /** The learner associated with this assigned RAP. */
  learner: LearnerProfile;
  rap: RegisteredApprenticeshipProgram;
  /** The start date of the assigned RAP. */
  startDate?: Maybe<Scalars['DateTime']['output']>;
  /** Competency tag associated with this assigned RAP which are not part of a group. */
  ungroupedCompetencyTags: Array<AssignedCompetencyTag>;
};

export type AssignedRapOrderBy = {
  endDate?: InputMaybe<SortOrder>;
  inactive?: InputMaybe<SortOrder>;
  learner?: InputMaybe<SortOrder>;
  startDate?: InputMaybe<SortOrder>;
};

export type AssociatedCredential = {
  __typename?: 'AssociatedCredential';
  activity?: Maybe<Activity>;
  credentialId: Scalars['String']['output'];
  /** Returns external ID of the credential, depends on the credential provider. */
  externalId: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  level?: Maybe<Level>;
  /** Returns the name of the LER credential. */
  name: Scalars['String']['output'];
  plan?: Maybe<Plan>;
  program?: Maybe<Program>;
  /** Returns the URL of the credential. */
  url: Scalars['String']['output'];
};

/** Represents the currently authenticated user, with a selected organization role, in context. This type should only ever be used to represent the currently logged in user, and not other users, as it requires that the input data has a non-null selected organization role. */
export type AuthenticatedUser = {
  __typename?: 'AuthenticatedUser';
  /** Evaluators assigned to this user */
  assignedEvaluators: Array<AppUser>;
  educationProvider?: Maybe<Organization>;
  email: Scalars['String']['output'];
  employer?: Maybe<Organization>;
  firstName: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  inactive: Scalars['Boolean']['output'];
  lastName: Scalars['String']['output'];
  middleName?: Maybe<Scalars['String']['output']>;
  organizationRoles: Array<OrganizationRole>;
  selectedOrganizationRole: OrganizationRole;
};

export type Avatar = {
  __typename?: 'Avatar';
  /** A base64 blur placeholder data URL for the user's Gravatar image, used by NextJS's image blur placeholder. Null when the user has no Gravatar set. */
  blurDataUrl?: Maybe<Scalars['String']['output']>;
  /** Whether the user has a real Gravatar image set. */
  exists: Scalars['Boolean']['output'];
  /** The full name of the user the avatar belongs to. */
  fullName: Scalars['String']['output'];
  /** The first and last name initials of the user the avatar belongs to, rendered in place of the image when no Gravatar is set. */
  initials: Scalars['String']['output'];
  /** The URL of the user's Gravatar image, resolved server-side and returned only when a real avatar exists so the client can render an optimized image without a 404 fallback. Null when the user has no Gravatar set. */
  url?: Maybe<Scalars['String']['output']>;
};


export type AvatarUrlArgs = {
  size?: InputMaybe<Scalars['Int']['input']>;
};

export type BatchTagUsersInput = {
  tags: Array<CreateTagInput>;
  userIds: Array<Scalars['ID']['input']>;
};

export type BooleanFilter = {
  equals?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['Boolean']['input']>;
  gte?: InputMaybe<Scalars['Boolean']['input']>;
  in?: InputMaybe<Array<Scalars['Boolean']['input']>>;
  lt?: InputMaybe<Scalars['Boolean']['input']>;
  lte?: InputMaybe<Scalars['Boolean']['input']>;
  not?: InputMaybe<BooleanFilter>;
};

export type Collaborative = {
  __typename?: 'Collaborative';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  /** Returns settings for this collaborative. */
  settings: CollaborativeSettings;
};

export type CollaborativeSettings = {
  __typename?: 'CollaborativeSettings';
  enableActivityReturnedNotifications: Scalars['Boolean']['output'];
  enableActivitySubmittedNotifications: Scalars['Boolean']['output'];
};

export enum CollaborativeSettingsEnum {
  EnableActivityReturnedNotifications = 'enableActivityReturnedNotifications',
  EnableActivitySubmittedNotifications = 'enableActivitySubmittedNotifications'
}

export type CompetencyTagGroupOrderBy = {
  name?: InputMaybe<SortOrder>;
};

export type CompleteProgramTimeEntry = EmptyProgramTimeEntry | ProgramTimeEntry;

export type CompleteProgramTimeEntryItem = EmptyProgramTimeEntryItem | ProgramTimeEntryItem;

export type ConfigureObservationTrackingInput = {
  categories?: InputMaybe<Array<ObservationCategoryAddition>>;
  customFields?: InputMaybe<Array<ObservationCustomFieldAddition>>;
  customLabels?: InputMaybe<Array<InputMaybe<Scalars['StandardOptionalUserInputString']['input']>>>;
  isPreApprovalEnabled: Scalars['Boolean']['input'];
  scoringMethod: ObservationScoringMethod;
  skills?: InputMaybe<Array<ObservationSkillAddition>>;
  targetScore?: InputMaybe<Scalars['TargetScore']['input']>;
};

export type ConfigureProgramTimeTrackingInput = {
  /** The individual items that a learner can track against the program. */
  items: Array<ProgramTimeItemInput>;
  schedule: TimeSchedule;
};

/** A general purpose Tag whose availability is governed by TagCluster context. */
export type ContentTag = {
  __typename?: 'ContentTag';
  /** Competency tags only, the competency tag group the tag is a part of. */
  competencyTagGroup?: Maybe<ContentTagGroup>;
  displayValue: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  /** The type of this tag, derived from the type of its parent cluster. */
  numTaggedActivities: Scalars['Int']['output'];
  tagCluster: ContentTagCluster;
  /** The type of this tag, derived from the type of its parent cluster. */
  type: ContentTagType;
  value: Scalars['String']['output'];
};

/** A cluster of tags available in an associated context. */
export type ContentTagCluster = {
  __typename?: 'ContentTagCluster';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  tagGroups: Array<ContentTagGroup>;
  tags: Array<ContentTag>;
};

/** A many-to-many group of tags, used for organization. */
export type ContentTagGroup = {
  __typename?: 'ContentTagGroup';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  /** The number of activities tagged with tags from this group. */
  numTaggedActivities: Scalars['Int']['output'];
  tagCluster: ContentTagCluster;
  /** The tags associated with this tag group. */
  tags: Array<ContentTag>;
};

export type ContentTagGroupFilterBy = {
  name?: InputMaybe<Scalars['String']['input']>;
};

export enum ContentTagType {
  Competency = 'COMPETENCY',
  General = 'GENERAL'
}

export type CreateAbsenceInput = {
  /** Optional comment. Required when reason is OTHER. */
  comment?: InputMaybe<Scalars['String']['input']>;
  /** Date of the absence */
  date: Scalars['DateTime']['input'];
  /** Duration of the absence */
  duration: AbsenceDuration;
  /** ID of the program for this absence */
  programId: Scalars['ID']['input'];
  /** Reason for the absence */
  reason: AbsenceReason;
};

export type CreateActivityFileData = {
  fileId: Scalars['NonEmptyString']['input'];
  fileName: Scalars['NonEmptyString']['input'];
  filePath: Scalars['NonEmptyString']['input'];
  mimeType: Scalars['NonEmptyString']['input'];
};

export type CreateActivityInput = {
  description?: InputMaybe<Scalars['NonEmptyString']['input']>;
  name: Scalars['NonEmptyString']['input'];
  planId: Scalars['ID']['input'];
  requiredArtifacts?: InputMaybe<Array<CreateActivityRequirementsInput>>;
};

export type CreateActivityLinkData = {
  displayText: Scalars['NonEmptyString']['input'];
  url: Scalars['NonEmptyString']['input'];
};

export type CreateActivityRequirementInput = {
  activityId: Scalars['ID']['input'];
  requiredArtifact: RequiredActivityArtifact;
  requirementAppliesTo: RequirementAppliesTo;
};

export type CreateActivityRequirementsInput = {
  requiredArtifact: RequiredActivityArtifact;
  requirementAppliesTo: RequirementAppliesTo;
};

export type CreateAssignedActivityFileData = {
  fileId: Scalars['NonEmptyString']['input'];
  fileName: Scalars['NonEmptyString']['input'];
  filePath: Scalars['NonEmptyString']['input'];
  mimeType: Scalars['NonEmptyString']['input'];
};

export type CreateAssignedActivityLinkData = {
  assignedActivityId: Scalars['ID']['input'];
  displayText: Scalars['NonEmptyString']['input'];
  url: Scalars['NonEmptyString']['input'];
};

export type CreateCollaborativeWithSponsorInput = {
  collaborativeName: Scalars['NonEmptyString']['input'];
  organizationName: Scalars['NonEmptyString']['input'];
};

export type CreateCompetencyTagData = {
  displayValue: Scalars['String']['input'];
  groupId?: InputMaybe<Scalars['String']['input']>;
  newGroupName?: InputMaybe<Scalars['String']['input']>;
  value: Scalars['String']['input'];
};

export type CreateFundingEntryInput = {
  amount: Scalars['Decimal']['input'];
  customFundingSource?: InputMaybe<Scalars['String']['input']>;
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  fundingSource: FundingSource;
  learnerId: Scalars['ID']['input'];
  notes?: InputMaybe<Scalars['String']['input']>;
  programId: Scalars['ID']['input'];
  startDate: Scalars['DateTime']['input'];
};

export type CreateLearnerCohortData = {
  description?: InputMaybe<Scalars['String']['input']>;
  /** The end date of the cohort. */
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  /** The start date of the cohort. */
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
  /** The state of the learner cohort. */
  state?: InputMaybe<LearnerCohortState>;
};

export type CreateLevelInput = {
  description?: InputMaybe<Scalars['NonEmptyString']['input']>;
  name: Scalars['NonEmptyString']['input'];
  programId: Scalars['ID']['input'];
};

export type CreateMultipleActivityLinksData = {
  displayText: Scalars['NonEmptyString']['input'];
  url: Scalars['NonEmptyString']['input'];
};

export type CreateMultipleActivityRequirementsInput = {
  requiredArtifact: RequiredActivityArtifact;
  requirementAppliesTo: RequirementAppliesTo;
};

export type CreateOrganizationSupportContactInput = {
  email: Scalars['NonEmptyString']['input'];
  organizationId: Scalars['ID']['input'];
  title?: InputMaybe<Scalars['NonEmptyString']['input']>;
};

export type CreatePlanInput = {
  assignToProgramLearners?: InputMaybe<Scalars['Boolean']['input']>;
  description?: InputMaybe<Scalars['NonEmptyString']['input']>;
  levelId: Scalars['ID']['input'];
  name: Scalars['NonEmptyString']['input'];
};

export type CreateProgramInput = {
  description?: InputMaybe<Scalars['NonEmptyString']['input']>;
  industry?: InputMaybe<IndustryId>;
  name: Scalars['NonEmptyString']['input'];
  occupationId?: InputMaybe<Scalars['ID']['input']>;
};

export type CreateTagInput = {
  organizationId: Scalars['ID']['input'];
  value: Scalars['NonEmptyString']['input'];
};

export type CreateUserInput = {
  address?: InputMaybe<AddressInput>;
  dateOfBirth?: InputMaybe<Scalars['DateOfBirth']['input']>;
  email: Scalars['EmailAddress']['input'];
  firstName: Scalars['NonEmptyString']['input'];
  hasNoAddress?: InputMaybe<Scalars['Boolean']['input']>;
  hasNoPhoneNumber?: InputMaybe<Scalars['Boolean']['input']>;
  inactiveReason?: InputMaybe<InactiveReason>;
  lastName: Scalars['NonEmptyString']['input'];
  middleName?: InputMaybe<Scalars['NonEmptyString']['input']>;
  organizationIds: Array<Scalars['ID']['input']>;
  phoneNumber?: InputMaybe<Scalars['NonEmptyString']['input']>;
  role: AppRole;
};

export type CredEngineCredentialInput = {
  activityId?: InputMaybe<Scalars['ID']['input']>;
  credentialEngineCtid: Scalars['String']['input'];
  levelId?: InputMaybe<Scalars['ID']['input']>;
  planId?: InputMaybe<Scalars['ID']['input']>;
  programId?: InputMaybe<Scalars['ID']['input']>;
};

export type CredentialEngineCredential = {
  __typename?: 'CredentialEngineCredential';
  /** The ctid of the credential */
  ctid: Scalars['String']['output'];
  /** The name of the credential */
  name: Scalars['String']['output'];
};

export enum CredentialProvider {
  CredentialEngine = 'CREDENTIAL_ENGINE',
  MapMyFuture = 'MAP_MY_FUTURE'
}

/** A criterion for a rubric. A rubric can have multiple criteria. Criterion are made of ratings. */
export type Criterion = {
  __typename?: 'Criterion';
  description?: Maybe<Scalars['String']['output']>;
  externalId?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  order: Scalars['Float']['output'];
  ratings: Array<Rating>;
  rubric: Rubric;
  /** Competency tags for this criterion. */
  tags: Array<ContentTag>;
};

export type CriterionInput = {
  description?: InputMaybe<Scalars['NonEmptyString']['input']>;
  name: Scalars['NonEmptyString']['input'];
};

/** The position of the new criterion in the list. */
export enum CriterionPosition {
  Above = 'ABOVE',
  Below = 'BELOW'
}

/** A criterion tag for a criterion. Criterion are made of ratings. */
export type CriterionTag = {
  __typename?: 'CriterionTag';
  criterion: Criterion;
  criterionId: Scalars['String']['output'];
  tag: ContentTag;
  tagId: Scalars['String']['output'];
};

export type DeleteActivityInput = {
  activityId: Scalars['ID']['input'];
};

export type DeleteAssignedPlansResult = {
  __typename?: 'DeleteAssignedPlansResult';
  successful: Array<AssignedPlanDeletionStatus>;
  unsuccessful: Array<AssignedPlanDeletionStatus>;
};

export type DeleteAssignedProgramsResult = {
  __typename?: 'DeleteAssignedProgramsResult';
  successful: Array<AssignedProgramDeletionStatus>;
  unsuccessful: Array<AssignedProgramDeletionStatus>;
};

export type DeleteLevelInput = {
  levelId: Scalars['ID']['input'];
};

export type DeleteMultipleActivityRequirementsInput = {
  requiredArtifact: RequiredActivityArtifact;
  requirementAppliesTo: RequirementAppliesTo;
};

export type DeleteOrganizationInput = {
  id: Scalars['ID']['input'];
};

export type DeleteOrganizationSupportContactInput = {
  id: Scalars['ID']['input'];
};

export type DeletePlanInput = {
  planId: Scalars['ID']['input'];
};

export type DeleteProgramInput = {
  programId: Scalars['ID']['input'];
};

export type DeleteRapInput = {
  rapId: Scalars['ID']['input'];
};

export type DisablePlanJoinCodeInput = {
  planId: Scalars['ID']['input'];
};

/** User email status from sendgrid */
export type EmailStatus = {
  __typename?: 'EmailStatus';
  /**
   * User email is blocked. Sendgrid will not send emails to this email.
   *         See their documentation for more information on blocked.
   */
  blocked: Scalars['Boolean']['output'];
  /**
   * User email is bounced. Sendgrid will not send emails to this email.
   *       See their documentation for more information on bounced.
   */
  bounced: Scalars['Boolean']['output'];
};

export type EmptyProgramTimeEntry = {
  __typename?: 'EmptyProgramTimeEntry';
  /** The evaluators available to this learner for time tracker submissions in this program's organization. */
  availableEvaluators: Array<UserProfile>;
  /** The items associated with this time entry. */
  items: Array<EmptyProgramTimeEntryItem>;
  /** The ID of the program associated with this unsaved/empty time entry. */
  programId: Scalars['ID']['output'];
  /** The ID of the user who this time entry is submitted for, usually a learner. */
  relatedUserId: Scalars['ID']['output'];
};

export type EmptyProgramTimeEntryItem = {
  __typename?: 'EmptyProgramTimeEntryItem';
  /** The total number of minutes logged for the item associated with this entry item, across all entries, excluding this entry item. */
  accumulatedOtherTime: Scalars['Int']['output'];
  item: ProgramTimeItem;
  /** The ID of the time item associated with this entry item. */
  itemId: Scalars['ID']['output'];
  /** The number of minutes associated with the time item , which will always be 0 for an empty item. */
  minutes: Scalars['Int']['output'];
  /** The ID of the program associated with this entry item. */
  programId: Scalars['ID']['output'];
  /** The ID of the user that is associated with the time entry that contains this entry item. */
  relatedUserId: Scalars['ID']['output'];
};

export type EnablePlanJoinCodeInput = {
  planId: Scalars['ID']['input'];
};

export type EvaluatorActivityRequirementsMap = {
  __typename?: 'EvaluatorActivityRequirementsMap';
  COMMENT: Scalars['Boolean']['output'];
  FILE: Scalars['Boolean']['output'];
  FILE_OR_LINK: Scalars['Boolean']['output'];
  LINK: Scalars['Boolean']['output'];
  OBSERVATION_DATE: Scalars['Boolean']['output'];
  SCORE: Scalars['Boolean']['output'];
};

export type ExternalCredentialInput = {
  activityId?: InputMaybe<Scalars['ID']['input']>;
  externalIdentifier: Scalars['TrimmedNonEmptyString']['input'];
  levelId?: InputMaybe<Scalars['ID']['input']>;
  planId?: InputMaybe<Scalars['ID']['input']>;
  programId?: InputMaybe<Scalars['ID']['input']>;
  provider: ExternalCredentialProvider;
};

export enum ExternalCredentialProvider {
  MapMyFuture = 'MAP_MY_FUTURE'
}

export enum FilterResultsEnum {
  All = 'ALL',
  Assigned = 'ASSIGNED',
  Unassigned = 'UNASSIGNED'
}

export enum FundingSource {
  Aba = 'ABA',
  H1BTrainingGrant = 'H1B_TRAINING_GRANT',
  Other = 'OTHER',
  Pell = 'PELL',
  Perkins = 'PERKINS',
  Saef = 'SAEF',
  Wioa = 'WIOA'
}

export enum InactiveReason {
  InvalidEmail = 'INVALID_EMAIL'
}

export type Industry = {
  __typename?: 'Industry';
  /** The standardized code string associated with the industry. */
  code: Scalars['IndustryCode']['output'];
  id: IndustryId;
  /** The human-readable name of the industry. */
  name: Scalars['IndustryName']['output'];
};

/** The enumerated identifier of an industry, as it is defined in the database. */
export enum IndustryId {
  AccommodationFoodServices = 'ACCOMMODATION_FOOD_SERVICES',
  AdministrativeSupportWasteManagementRemediationServices = 'ADMINISTRATIVE_SUPPORT_WASTE_MANAGEMENT_REMEDIATION_SERVICES',
  AgricultureForestryFishingHunting = 'AGRICULTURE_FORESTRY_FISHING_HUNTING',
  ArtsEntertainmentRecreation = 'ARTS_ENTERTAINMENT_RECREATION',
  Construction = 'CONSTRUCTION',
  EducationalServices = 'EDUCATIONAL_SERVICES',
  FinanceInsurance = 'FINANCE_INSURANCE',
  HealthcareSocialAssistance = 'HEALTHCARE_SOCIAL_ASSISTANCE',
  Information = 'INFORMATION',
  ManagementOfCompaniesEnterprises = 'MANAGEMENT_OF_COMPANIES_ENTERPRISES',
  Manufacturing = 'MANUFACTURING',
  Mining = 'MINING',
  OtherServicesExceptPublicAdministration = 'OTHER_SERVICES_EXCEPT_PUBLIC_ADMINISTRATION',
  ProfessionalScientificTechnicalServices = 'PROFESSIONAL_SCIENTIFIC_TECHNICAL_SERVICES',
  PublicAdministration = 'PUBLIC_ADMINISTRATION',
  RealEstateRentalLeasing = 'REAL_ESTATE_RENTAL_LEASING',
  RetailTrade = 'RETAIL_TRADE',
  TransportationWarehousing = 'TRANSPORTATION_WAREHOUSING',
  Utilities = 'UTILITIES',
  WholesaleTrade = 'WHOLESALE_TRADE'
}

export type IntFilter = {
  equals?: InputMaybe<Scalars['Int']['input']>;
  gt?: InputMaybe<Scalars['Int']['input']>;
  gte?: InputMaybe<Scalars['Int']['input']>;
  in?: InputMaybe<Array<Scalars['Int']['input']>>;
  lt?: InputMaybe<Scalars['Int']['input']>;
  lte?: InputMaybe<Scalars['Int']['input']>;
  not?: InputMaybe<IntFilter>;
};

export type IsAssignedToPlanWhereInput = {
  planId: Scalars['ID']['input'];
};

export type JoinPlanResponse = {
  __typename?: 'JoinPlanResponse';
  alreadyJoined: Scalars['Boolean']['output'];
  assignedPlan: AssignedPlan;
};

export type LearnerActivityRequirementsMap = {
  __typename?: 'LearnerActivityRequirementsMap';
  COMMENT: Scalars['Boolean']['output'];
  DURATION: Scalars['Boolean']['output'];
  FILE: Scalars['Boolean']['output'];
  FILE_OR_LINK: Scalars['Boolean']['output'];
  LINK: Scalars['Boolean']['output'];
};

export type LearnerActivityStats = {
  __typename?: 'LearnerActivityStats';
  approved: Scalars['Int']['output'];
  overdue: Scalars['Int']['output'];
  pending: Scalars['Int']['output'];
  returned: Scalars['Int']['output'];
  unsubmitted: Scalars['Int']['output'];
};

export type LearnerCohort = {
  __typename?: 'LearnerCohort';
  /** The date and time that this cohort was created. */
  createdAt: Scalars['DateTime']['output'];
  /** The user who created this learner cohort. */
  createdBy?: Maybe<UserProfile>;
  description?: Maybe<Scalars['String']['output']>;
  /** The date and time in which this cohort becomes inactive. */
  endDate?: Maybe<Scalars['DateTime']['output']>;
  /** Returns the facilitators in the cohort. */
  facilitators: Array<UserProfile>;
  /** Whether or not the currently authenticated user has favorited this cohort. */
  favorited: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  /** Returns the instructors in the cohort. */
  instructors: Array<UserProfile>;
  /** Returns the learners in the cohort. */
  learners: Array<UserProfile>;
  name: Scalars['String']['output'];
  /** The date and time in which this cohort becomes active. */
  startDate?: Maybe<Scalars['DateTime']['output']>;
  state: LearnerCohortState;
  /** The last time this cohort was updated. */
  updatedAt: Scalars['DateTime']['output'];
  /** The user who last updated this learner cohort. */
  updatedBy?: Maybe<UserProfile>;
};

export type LearnerCohortAssignableUser = {
  id: Scalars['ID']['input'];
  type: LearnerCohortAssignableUserType;
};

/** The types (or roles) of users that are allowed to be assigned to a learner cohort. */
export enum LearnerCohortAssignableUserType {
  Facilitator = 'FACILITATOR',
  Instructor = 'INSTRUCTOR',
  Learner = 'LEARNER'
}

/** Filters that can be used for querying learner cohorts. */
export type LearnerCohortFilters = {
  /** A search term to filter the learner cohorts by. */
  search?: InputMaybe<StringFilter>;
  /** An array of learner cohort states to filter by */
  state?: InputMaybe<Array<LearnerCohortState>>;
};

export enum LearnerCohortState {
  Active = 'ACTIVE',
  Archived = 'ARCHIVED'
}

export enum LearnerCohortUserSortFieldEnum {
  Email = 'email',
  Name = 'name'
}

export type LearnerCohortUserSortOrderBy = {
  field: LearnerCohortUserSortFieldEnum;
  sortOrder: SortOrder;
};

/** Filters that can be used for filtering the learners and/or facilitators in a cohort. */
export type LearnerCohortUsersFilters = {
  /** The order by which to sort the users. */
  orderBy?: InputMaybe<Array<LearnerCohortUserSortOrderBy>>;
  /** A search term to filter the learners or facilitators in the cohort by. */
  search?: InputMaybe<StringFilter>;
  /** Tags to filter the users by. */
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type LearnerEvaluatorsInput = {
  evaluatorIds: Array<Scalars['ID']['input']>;
  learnerId: Scalars['ID']['input'];
};

export type LearnerFundingEntry = {
  __typename?: 'LearnerFundingEntry';
  amount: Scalars['Decimal']['output'];
  /** Whether the calling viewer is permitted to delete this entry. Shares the same owner-or-related-admin rule as `canEdit` today; modeled as a separate field so future product rules can diverge edit and delete permissions without a breaking schema change. */
  canDelete: Scalars['Boolean']['output'];
  /** Whether the calling viewer is permitted to edit this entry. Driven server-side from the same owner-or-related-admin rule the `updateFundingEntry` mutation enforces; the frontend must consume this flag rather than reproduce the authorization logic. */
  canEdit: Scalars['Boolean']['output'];
  createdAt: Scalars['DateTime']['output'];
  customFundingSource?: Maybe<Scalars['String']['output']>;
  /** The funding source resolved to a single display string: the human label for a Craft-managed source, or the custom name when the source is Other. The frontend renders this directly without branching on the enum. */
  displaySource: Scalars['String']['output'];
  endDate?: Maybe<Scalars['DateTime']['output']>;
  fundingSource: FundingSource;
  id: Scalars['ID']['output'];
  learner: AppUser;
  learnerId: Scalars['String']['output'];
  notes?: Maybe<Scalars['String']['output']>;
  program: Program;
  programId: Scalars['String']['output'];
  reportedBy: AppUser;
  startDate: Scalars['DateTime']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type LearnerObservationCategory = ObservationCategoryInterface & {
  __typename?: 'LearnerObservationCategory';
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  learnerId: Scalars['ID']['output'];
  name: Scalars['StandardUserInputString']['output'];
  skills: Array<LearnerObservationSkill>;
  updatedAt: Scalars['DateTime']['output'];
};

export type LearnerObservationSkill = SkillInterface & {
  __typename?: 'LearnerObservationSkill';
  attempts: Array<ObservationAttempt>;
  competentAttempts: Array<ScoredObservationAttempt>;
  configuration: ProgramObservationTracking;
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  isLocked: Scalars['Boolean']['output'];
  latestScoredAttempt?: Maybe<ScoredObservationAttempt>;
  learnerId: Scalars['ID']['output'];
  minimumSuccessfulAttempts?: Maybe<Scalars['MinimumSuccessfulAttempts']['output']>;
  name: Scalars['LongUserInputString']['output'];
  numCompetentAttempts: Scalars['Int']['output'];
  program: Program;
  repeatable: Scalars['Boolean']['output'];
  scoredAttempts: Array<ScoredObservationAttempt>;
  state: ObservationSkillState;
  unScoredAttempts: Array<UnScoredObservationAttempt>;
  updatedAt: Scalars['DateTime']['output'];
};

/** Sort options for a Learner record */
export type LearnerOrderBy = {
  firstName?: InputMaybe<SortOrder>;
};

export type LearnerProfile = {
  __typename?: 'LearnerProfile';
  /** Evaluators assigned to the learner */
  assignedEvaluators: Array<UserProfile>;
  /** Programs assigned to the learner. Optional filter by program ID */
  assignedPrograms: Array<AssignedProgram>;
  /** Evaluators available to be assigned to the learner */
  availableEvaluators: Array<UserProfile>;
  /** Indicates if the learner has been cleared in the current organization */
  cleared?: Maybe<Scalars['Boolean']['output']>;
  /** The learner's education provider in the collaborative */
  educationProvider?: Maybe<Organization>;
  /** The learner's employer in the collaborative */
  employer?: Maybe<Organization>;
  /** User profile */
  userProfile: UserProfile;
};


export type LearnerProfileAssignedProgramsArgs = {
  programId?: InputMaybe<Scalars['ID']['input']>;
};

export type LearnerProgramObservationTracking = {
  __typename?: 'LearnerProgramObservationTracking';
  categories: Array<LearnerObservationCategory>;
  configuration: ProgramObservationTracking;
  learnerId: Scalars['ID']['output'];
  programId: Scalars['ID']['output'];
  scoringMethod: ObservationScoringMethod;
  skills: Array<LearnerObservationSkill>;
};

export type LearnerProgramTrackedTime = {
  __typename?: 'LearnerProgramTrackedTime';
  /** The total number of minutes that the learner has logged for the program. */
  completedTargetMinutes: Scalars['Int']['output'];
  learnerId: Scalars['ID']['output'];
  /** The most recent time entry for the learner in this program, if one exists. */
  mostRecentTimeEntry?: Maybe<ProgramTimeEntry>;
  programId: Scalars['ID']['output'];
  /** The total number of target hours for all time items the program is configured for less the total number of minutes logged by the learner for the program.  Returned in minutes. */
  remainingTargetMinutes: Scalars['Int']['output'];
  timeSchedule: TimeSchedule;
  trackedItems: Array<LearnerProgramTrackedTimeItem>;
};

export type LearnerProgramTrackedTimeItem = {
  __typename?: 'LearnerProgramTrackedTimeItem';
  /** The time item associated with these metrics. */
  item: ProgramTimeItem;
  /** The ID of the time item associated with these metrics. */
  itemId: Scalars['ID']['output'];
  loggedMinutes: TrackedTimeItemLoggedMinutes;
};

export type LearnerWageEntry = {
  __typename?: 'LearnerWageEntry';
  amount: Scalars['Decimal']['output'];
  /** Whether the calling viewer is permitted to delete this entry. Shares the same owner-or-admin rule as `canEdit` today (`deleteWageEntry` reuses the edit-permission helper); modeled as a separate field so future product rules can diverge edit and delete permissions without a breaking schema change. Selecting both `canEdit` and `canDelete` on the same row resolves the second in O(1) — no extra DB work. */
  canDelete: Scalars['Boolean']['output'];
  /** Whether the calling viewer is permitted to edit this entry. Driven server-side from the same owner-or-admin rule the `updateWageEntry` mutation enforces; the frontend must consume this flag rather than reproduce the authorization logic. */
  canEdit: Scalars['Boolean']['output'];
  createdAt: Scalars['DateTime']['output'];
  effectiveDate: Scalars['DateTime']['output'];
  employer: Organization;
  employerId: Scalars['String']['output'];
  entryDate: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  learner: AppUser;
  learnerId: Scalars['String']['output'];
  program: Program;
  programId: Scalars['String']['output'];
  rateUnit: WageRateUnit;
  reason?: Maybe<Scalars['String']['output']>;
  reportedBy: AppUser;
  reportedById: Scalars['String']['output'];
  reporter: WageReporter;
  updatedAt: Scalars['DateTime']['output'];
};

/** Filters that can be used for querying learners associated with assigned activities that are pending approval. */
export type LearnersWithAssignedActivitiesPendingApprovalFilters = {
  /** A search term to filter the learners by. */
  search?: InputMaybe<StringFilter>;
};

export type Level = {
  __typename?: 'Level';
  /** The LER credential associated with this level */
  associatedCredential?: Maybe<AssociatedCredential>;
  description?: Maybe<Scalars['String']['output']>;
  displayOrder: Scalars['Int']['output'];
  externalId?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  /** The organization id that this level belongs to. */
  organizationId: Scalars['ID']['output'];
  /**
   * Returns this level's plans.
   *       If you are an instructor they are filtered to be only the plans assigned to that instructor.
   */
  plans: Array<Plan>;
  program: Program;
  programId: Scalars['String']['output'];
};

export type LevelLockInput = {
  levelId: Scalars['String']['input'];
  unlockOn?: InputMaybe<Scalars['DateTime']['input']>;
};

export type LtiAssignedActivity = {
  __typename?: 'LtiAssignedActivity';
  assignedActivityId: Scalars['ID']['output'];
  createdAssociation: Scalars['Boolean']['output'];
  ltiAssignmentId: Scalars['String']['output'];
  ltiClassId: Scalars['String']['output'];
  ltiSubmissionId: Scalars['String']['output'];
};

export type Mutation = {
  __typename?: 'Mutation';
  addCriterion: Criterion;
  addRating: Rating;
  addRole: OrganizationRole;
  /** Adds a rubric with default values to the users current organization. */
  addRubric: Rubric;
  addSponsoredOrganization: Organization;
  addUserToOrganization: OrganizationRole;
  /** Deactivates a user account on behalf of a SystemAdmin. */
  adminDeactivateUser: UserProfile;
  /** Reactivates a user account on behalf of a SystemAdmin. */
  adminReactivateUser: UserProfile;
  /** Removes one Edlink source from an organization, leaving any others it holds in place. SystemAdmin only. */
  adminRemoveOrganizationEdlinkIntegration: AdminEdlinkOrganization;
  /** Adds an Edlink source to an organization, or edits one in place when a row id is given. Other sources the organization holds are untouched. SystemAdmin only. */
  adminSaveOrganizationEdlinkIntegration: AdminEdlinkOrganization;
  /** Records or clears an organization's in-progress Edlink onboarding id, leaving the sources it has connected untouched. SystemAdmin only. */
  adminUpdateOrganizationEdlinkOnboarding: AdminEdlinkOrganization;
  /** Updates the target user's email address on behalf of a Craft admin. SystemAdmin only. */
  adminUpdateUserEmail: UserProfile;
  /** Approves a list of assigned activities.Creates a submission for the activity. Associates any links or files that were created before the submission with the submission. This mutation is used to approve a list of activities that was submitted. */
  approveAssignedActivities: Array<AssignedActivity>;
  approveProgramTimeEntry: ProgramTimeEntryReview;
  /** Archives a rubric. Removes it from all activities it is attached to. */
  archiveRubric: Rubric;
  /** Assigns an instructor to a plan. */
  assignInstructorToPlan: AssignedInstructor;
  /** Assigns learners to a plan and its child activities. */
  assignLearnersToPlan: Array<AssignedPlan>;
  /** Assigns learners to a program and its child content. */
  assignLearnersToProgram: Array<AssignedProgram>;
  /** Assigns learners to a RAP. */
  assignLearnersToRap: Array<AssignedRap>;
  assignUsersToLearnerCohort: LearnerCohort;
  attachRubricToActivities: Array<Activity>;
  /** Takes a list of user IDs and a list of tags, and assigns those tags to the relevant users. */
  batchTagUsers: Array<AppUser>;
  /** Sets the due date on an activity. Only available to non learner roles. */
  batchUpdateActivityDueDates: Array<AssignedActivity>;
  /** Configure observation tracking for a program */
  configureObservationTracking: ProgramObservationTracking;
  configureOrganizationForLearner: OrganizationRole;
  configureProgramTimeTracking: ProgramTrackedTime;
  /** Create a new absence record for the current user */
  createAbsence: Absence;
  createActivity: Activity;
  /** Tags an activity in a RAP with a competency tag from that RAP's cluster. */
  createActivityCompetencyTag: ActivityTag;
  /** Creates an entry for a file uploaded to an activity. The client will get a s3 presigned url, upload the file, then create an entry in the database with this resolver. */
  createActivityFile: ActivityFile;
  /** Generates a presigned url for downloading an activity file. */
  createActivityFileDownloadUrl: Scalars['String']['output'];
  /** Generates a presigned url for previewing an activity file. */
  createActivityFilePreviewUrl: Scalars['String']['output'];
  /** Generates a presigned url for uploading an activity file. */
  createActivityFileUploadUrl: Scalars['String']['output'];
  /** Creates a link for an Activity. */
  createActivityLink: ActivityLink;
  createActivityRequirement: ActivityRequirement;
  createActivityReview: ActivityReview;
  /**
   * Creates an entry for a file uploaded to an assigned activity.
   *       The client will get a s3 presigned url, upload the file, then create an entry in the
   *       database with this resolver.
   */
  createAssignedActivityFile: AssignedActivityFile;
  /** Generates a download URL for an assigned activity file. */
  createAssignedActivityFileDownload: AssignedActivityFileDownload;
  /** Generates a presigned url for downloading an assigned activity file. */
  createAssignedActivityFileDownloadUrl: Scalars['String']['output'];
  /** Generates a presigned url for previewing an assigned activity file. */
  createAssignedActivityFilePreviewUrl: Scalars['String']['output'];
  /** Generates a presigned url for uploading an assigned activity file. */
  createAssignedActivityFileUploadUrl: Scalars['String']['output'];
  /** Creates a link for an assigned activity. Does not need to be associated with a submission at time of creation. */
  createAssignedActivityLink: AssignedActivityLink;
  /** Create a new collaborative with a sponsor organization. Only available to Craft admins.The current craft admin will be added as an admin of the sponsor organization. */
  createCollaborativeWithSponsor: Array<Organization>;
  /** Creates a new competency tag in a RAP's competency cluster. The a group ID can be provided to add the tag to a group on creation, or newGroupName can be provided to create a new group and add the tag. Only available to sponsor admins. */
  createCompetencyTag: ContentTag;
  /** Tags a criterion of a rubric in a RAP with a competency tag from that RAP's cluster. */
  createCriterionCompetencyTag: CriterionTag;
  /** Creates a funding entry for a learner. The learner may create their own entries; a related funding-capable admin may create entries on a learner's behalf. Returns the created entry. */
  createFundingEntry: LearnerFundingEntry;
  createLearnerCohort: LearnerCohort;
  createLevel: Level;
  /** Creates an activity link for each specified activity. */
  createMultipleActivityLinks: Array<ActivityLink>;
  /** Creates an activity requirement for each specified activity. */
  createMultipleActivityRequirements: Array<ActivityRequirement>;
  /** Create a named support contact for an organization. */
  createOrganizationSupportContact: OrganizationSupportContact;
  createPlan: Plan;
  createProgram: Program;
  createRap: RegisteredApprenticeshipProgram;
  createUser: UserProfile;
  createUserEmail: AppUserEmail;
  /** Delete an absence record */
  deleteAbsence: Absence;
  deleteActivity: Activity;
  /** Untags an activity in a RAP with a competency tag. */
  deleteActivityCompetencyTag: ActivityTag;
  /** Deletes a file from an Activity. */
  deleteActivityFile: ActivityFile;
  /** Deletes a link from an Activity. */
  deleteActivityLink: ActivityLink;
  /** Deletes all files from an Activity. */
  deleteAllActivityFiles: Array<ActivityFile>;
  /** Deletes all links from an Activity. */
  deleteAllActivityLinks: Array<ActivityLink>;
  /** Un-tags all activities in a program from a given tag. */
  deleteAllContentTagsInProgram: ContentTag;
  /** Deletes an assignedActivityFile record from the database using the provided ID. */
  deleteAssignedActivityFile: AssignedActivityFile;
  /** Deletes an assignedActivityLink record from the database using the provided ID. */
  deleteAssignedActivityLink: AssignedActivityLink;
  /** Deletes an assigned plan, unassigning a the learner from the plan. All learner content under the plan is destroyed! */
  deleteAssignedPlan: AssignedPlan;
  /** Deletes a list of assigned plans. Available to Admins and Instructors. */
  deleteAssignedPlans?: Maybe<DeleteAssignedPlansResult>;
  /** Deletes an assigned program, unassigning the learner from the program. All learner program content is destroyed! */
  deleteAssignedProgram: AssignedProgram;
  /** Delete a list of assigned programs, unassigning the learner from the program.All learner program content is destroyed! */
  deleteAssignedPrograms?: Maybe<DeleteAssignedProgramsResult>;
  /** Removes a learner from a RAP. */
  deleteAssignedRap: AssignedRap;
  /** Deletes a competency tag. Only available to sponsor admins. */
  deleteCompetencyTag: ContentTag;
  /** Deletes a competency tag group. Only available to sponsor admins. */
  deleteCompetencyTagGroup: ContentTagGroup;
  /** Deletes a criterion. Can only be done if the rubric is in draft state. */
  deleteCriterion: Criterion;
  /** Untags a criterion of a rubric in a RAP with a competency tag. */
  deleteCriterionCompetencyTag: CriterionTag;
  /** Deletes a rubric by its ID. Requires rubric to be in draft state. */
  deleteDraftRubric: Rubric;
  /** Hard-deletes a funding entry. Owner-or-related-admin authorization (the same rule as the entry's `canDelete` flag). Returns `true` on success; errors with NOT_AUTHORIZED if the caller cannot delete the entry, or INTERNAL_SERVER_ERROR if the entry no longer exists by the time the resolver runs (an unexpected concurrent delete). */
  deleteFundingEntry: Scalars['Boolean']['output'];
  deleteLearnerCohort: LearnerCohort;
  deleteLevel: Level;
  /** Deletes an activity requirement from each specified activity. */
  deleteMultipleActivityRequirements: Array<ActivityRequirement>;
  /** Delete the observation module for a program */
  deleteObservationTracking: Program;
  /** Deletes an organization and all associated data */
  deleteOrganization: Organization;
  /** Deletes an organization support contact */
  deleteOrganizationSupportContact: OrganizationSupportContact;
  deletePlan: Plan;
  deleteProgram: Program;
  deleteProgramTimeEntry: ProgramTimeEntry;
  deleteRap: RegisteredApprenticeshipProgram;
  /** Deletes a rating. Can only be done if the rubric is in draft state. */
  deleteRating: Rating;
  /** Deletes a tag from the database by ID. This will also remove the tag from any users it is assigned to. */
  deleteTag: UserTag;
  deleteUserEmail: AppUserEmail;
  deleteUserExternalId: UserProfile;
  /** Hard-deletes a wage entry. Owner-or-admin authorization; the admin path is allowlisted to EMPLOYER, SPONSOR, and EDUCATION_PROVIDER org types within their employer scope (own org for EMPLOYER admins; any EMPLOYER in a shared collaborative for SPONSOR and EDUCATION_PROVIDER admins). Other admin org types (e.g. SYSTEM_ADMIN) are denied. Returns `true` on success; errors with NOT_AUTHORIZED if the caller cannot delete the entry, or INTERNAL_SERVER_ERROR if the entry no longer exists by the time the resolver runs (an unexpected concurrent delete). */
  deleteWageEntry: Scalars['Boolean']['output'];
  detachRubricFromActivities: Array<Activity>;
  disableJoinCode: Plan;
  /** Deletes the activity review, which cascade deletes all associated comments and ratings. */
  discardSelectedRatingsAndComments: ActivityReview;
  /** This mutation only exists to dispatch an event indicating that an activity has been selected to be associated with an LTI assignment. The id of the assignment itself is not an argument because the assignment might not yet exist. */
  dispatchLtiAssociateActivityEvent: Scalars['Boolean']['output'];
  duplicateActivity: Activity;
  duplicateLevel: Level;
  duplicatePlan: Plan;
  duplicateProgram: Program;
  duplicateRubric: Rubric;
  enableJoinCode: Plan;
  /**
   * Enter an organization as an admin. Upserts the role.
   *     Adds the organization access control for the user.
   *      Only available to sponsor or system admins.
   */
  enterOrganizationAsAdmin: AuthenticatedUser;
  favoriteLearnerCohort: LearnerCohort;
  /**
   * This mutation changes nothing in the database but makes it easy for the client
   *       to invalidate the URQL cache for the selected types. This is useful when
   *       we update data in the database without using GraphQL. For example, when we import data
   *       via CSV. Call the mutation like this:
   *       import { useInvalidateUrqlCacheMutation } from '@/generated/graphql';
   *       const [state, mutation] = useInvalidateUrqlCacheMutation();
   *       await mutation({}, { additionalTypenames: ['AssignedProgram'] });
   */
  invalidateUrqlCache: Scalars['Boolean']['output'];
  joinPlan: JoinPlanResponse;
  linkCredEngineCredential: AssociatedCredential;
  linkExternalCredential: AssociatedCredential;
  publishRap: RegisteredApprenticeshipProgram;
  /** Puts a drafted rubric in the published state. Only available to admins. */
  publishRubric: Rubric;
  /** Reassign one or more learners to a program by updating their status from WITHDRAWN to ASSIGNED and updating their start and anticipated end dates. Accepts single or multiple assigned program IDs. */
  reassignLearnersToProgram: Array<AssignedProgram>;
  /** Records a wage entry on behalf of a learner. Allowlisted to EMPLOYER, SPONSOR, and EDUCATION_PROVIDER admins related to the learner whose target employer is within their write scope (own org for EMPLOYER admins; any EMPLOYER in a shared collaborative for SPONSOR and EDUCATION_PROVIDER admins). Other admin org types (e.g. SYSTEM_ADMIN) are denied; expanding the allowlist requires a deliberate change in the shared wage-entry permission helper. Reporter attribution is server-derived. POLICY: no entry-level restrictions (duplicates, rapid succession, etc.) are enforced server-side pending real-world usage feedback; the FE warns on duplicate dates as UX only. */
  recordWageEntryForLearner: LearnerWageEntry;
  removeActivityRequirement: ActivityRequirement;
  removeRoleById: OrganizationRole;
  /** Removes a sponsored organization pending there is no content associated with it */
  removeSponsoredOrganization: Organization;
  /** Removes the association between the learner cohort and facilitators, instructors or learners. */
  removeUsersFromLearnerCohort: LearnerCohort;
  /** Renames a tag. Takes the desired new value of the tag and the ID of the tag to update. */
  renameTag: UserTag;
  /** Reorders a rubric's criteria. */
  reorderCriterion: Array<Criterion>;
  /** Reorders a criterion's ratings. */
  reorderRatings: Array<Rating>;
  /** Learner requesting an evaluation */
  requestEvaluation: Array<UnScoredObservationAttempt>;
  /** Return a list of activities. Creates a submission for the activity. Associates any links or files that were created before the submission with the submission. This mutation is used to return a list of activities that was submitted or previously approved. */
  returnAssignedActivities: Array<AssignedActivity>;
  returnProgramTimeEntry: ProgramTimeEntryReview;
  /** Creates, updates, or removes a comment on an assigned activity. Does not need to be associated with a submission at time of creation. */
  saveAssignedActivityComment?: Maybe<AssignedActivityComment>;
  /** Saves an observation date of an assigned activity. Does not need to be associated with a submission at time of creation. */
  saveObservationDate?: Maybe<AssignedActivityObservationDate>;
  /** Allows an active evaluator assigned to the learner to score an observation attempt. An active designated observer has exclusive access; otherwise the attempt falls back to the active assigned evaluator pool. The attempt must not already be scored, and the score must be consistent with the program scoring method. */
  scoreObservationAttempt: ScoredObservationAttempt;
  selectOrganizationRoleForAppUser: AuthenticatedUser;
  sendEmailVerificationLink: AppUserEmail;
  /** Send an assigned activity to Edlink */
  sendLtiAssignedActivity: LtiAssignedActivity;
  /** Sets the unlock date for this assigned level. Used in conjunction with levelLockSetting in the parent program. */
  setAssignedLevelUnlockedOn: AssignedLevel;
  /** Update a setting on the collaborative. */
  setCollaborativeSetting: CollaborativeSettings;
  /** Sets the due date on an activity. Only available to non learner roles. */
  setDueDateOnActivity: AssignedActivity;
  setLearnersEvaluators: Array<LearnerProfile>;
  /** Sets the lock setting for a program. Used in conjunction with an unlock date on the assigned level. Only available to admins. */
  setLevelLockSetting: Program;
  /** Set the na rating configuration for a rubric. */
  setRubricNaRatingConfiguration: Rubric;
  /** Set the numeric scores configuration for a rubric. If enabled, the numeric scores will be set to the order of the rating */
  setRubricNumericScoresConfiguration: Rubric;
  /** Creates a new submission for an assigned activity and updates the status of the assigned activity. If a comment is provided, a new comment will be created for the submission. Any files or links that were not previously submitted will be associated with the submission. Can be called by any user with a role of learner or higher. Authorization depends on role and new status. */
  submitActivity: AssignedActivity;
  /** Records a wage entry submitted by the current learner. Reporter attribution is server-derived; learners may only submit entries for themselves. POLICY: no entry-level restrictions (duplicates, rapid succession, etc.) are enforced server-side pending real-world usage feedback; the FE warns on duplicate dates as UX only. */
  submitLearnerWageEntry: LearnerWageEntry;
  submitProgramTimeEntry: ProgramTimeEntry;
  /** Allows an evaluator or admin to both request an evaluation on behalf of a learner and score that attempt at the same time. */
  submitScoredObservationAttempts: Array<ScoredObservationAttempt>;
  /** Takes a user ID and a list of tags, and assigns those tags to the relevant user. If a corresponding organization tag does not exist, it will be created. Returns affected user. */
  tagUser: AppUser;
  /** Unarchives a rubric. Does not reinstate activity connections on unarchival. */
  unarchiveRubric: Rubric;
  /** Unassigns an instructor from a plan. */
  unassignInstructorToPlan: AssignedInstructor;
  unfavoriteLearnerCohort: LearnerCohort;
  unlinkContentFromCredential: AssociatedCredential;
  /** Unlocks one or more skills for a learner. */
  unlockSkills: Array<LearnerObservationSkill>;
  /** Deletes multiple tags from a user. */
  untagUser: AppUser;
  /** Update an existing absence record */
  updateAbsence: Absence;
  updateActivityDescription: Activity;
  updateActivityExternalId: Activity;
  updateActivityName: Activity;
  updateActivityOrder: Array<Activity>;
  /** Updates the target ratings for a given activity. */
  updateActivityTargetRatings: Array<TargetRating>;
  /** Sets the time spent on an assigned activity. Some users do not track this value therefore it can be set to undefined. */
  updateAssignedActivityTimeSpent: AssignedActivity;
  /** Sets the unlock date for a list of assigned levels. Available to admins and instructors. */
  updateAssignedLevelUnlockDates: Array<AssignedLevel>;
  /** Sets the date range for an assigned program. Available to admins. */
  updateAssignedProgramDateRange: AssignedProgram;
  updateAssignedProgramDates: Array<AssignedProgram>;
  /** Updates the start and end date of an assigned RAP. */
  updateAssignedRapDates: AssignedRap;
  /** Updates a competency tag. Only available to sponsor admins. */
  updateCompetencyTag: ContentTag;
  /** Used to update a criterion's name and description. */
  updateCriterion: Criterion;
  /** Update the external ID of a criterion. */
  updateCriterionExternalId: Criterion;
  /** Updates the activity due dates for an assigned level. Available to admins. */
  updateDueDatesByAssignedLevel: Array<AssignedActivity>;
  /** Updates the activity due dates for an assigned plan. Available to admins and instructors. */
  updateDueDatesByAssignedPlan: Array<AssignedActivity>;
  /** Updates an existing funding entry. Owner-or-related-admin authorization (the same rule as the entry's `canEdit` flag). Program eligibility is re-checked only when the program changes, so non-program edits remain possible after a program becomes inactive. Cross-field rules are validated against the merged state of the existing entry and the patch. */
  updateFundingEntry: LearnerFundingEntry;
  updateLearnerCohort: LearnerCohort;
  updateLearnerCohorts: Array<LearnerCohort>;
  updateLevelDescription: Level;
  updateLevelExternalId: Level;
  updateLevelName: Level;
  updateLevelOrder: Array<Level>;
  /** Update observation tracking for a program */
  updateObservationTracking: ProgramObservationTracking;
  /** Update the name of an organization. */
  updateOrganizationName: Organization;
  /** Update the cleared status of an organization role. */
  updateOrganizationRoleClearedStatus: OrganizationRole;
  /** Edit an organization support contact */
  updateOrganizationSupportContact: OrganizationSupportContact;
  updatePlanDescription: Plan;
  updatePlanExternalId: Plan;
  updatePlanName: Plan;
  updatePlanOrder: Array<Plan>;
  updateProgram: Program;
  updateProgramAbsenceTrackingEnabled: Program;
  updateProgramCourseworkEnabled: Program;
  updateProgramDescription: Program;
  updateProgramExternalId: Program;
  updateProgramName: Program;
  updateProgramOrder: Array<Program>;
  updateProgramState: Program;
  updateProgramTimeTracking: ProgramTrackedTime;
  updateRap: RegisteredApprenticeshipProgram;
  updateRapOrder: Array<RegisteredApprenticeshipProgram>;
  /** Used to update a rating's label, description, and score. */
  updateRating: Rating;
  /** Update the external ID of a rubric. */
  updateRubricExternalId: Rubric;
  /** Update the name and description of a rubric. If the name is not provided, it will not be updated. */
  updateRubricNameOrDescription: Rubric;
  updateUser: UserProfile;
  updateUserExternalId: UserProfile;
  updateUserPrimaryEmail: UserProfile;
  /** Updates an existing wage entry. Owner-or-admin authorization; the admin path is allowlisted to EMPLOYER, SPONSOR, and EDUCATION_PROVIDER org types within their employer scope (own org for EMPLOYER admins; any EMPLOYER in a shared collaborative for SPONSOR and EDUCATION_PROVIDER admins). Other admin org types (e.g. SYSTEM_ADMIN) are denied. Original reporter attribution is preserved across edits. POLICY: no entry-level restrictions (duplicates, rapid succession, etc.) are enforced server-side pending real-world usage feedback; the FE warns on duplicate dates as UX only. */
  updateWageEntry: LearnerWageEntry;
  /** Creates or updates a scored criterion, which represents a comment and rating combination. */
  upsertScoredCriterion: ScoredCriterion;
  /** Withdraw one or more learners from an assignment by updating their status to WITHDRAWN. Programs become read-only. Accepts single or multiple assigned program IDs. Requirements: Learner must be ACTIVE (have at least one submitted activity), not COMPLETED (all activities approved), not already WITHDRAWN, Program not ARCHIVED. */
  withdrawLearnersFromProgram: Array<AssignedProgram>;
};


export type MutationAddCriterionArgs = {
  criterionId: Scalars['ID']['input'];
  duplicate?: InputMaybe<Scalars['Boolean']['input']>;
  position: CriterionPosition;
};


export type MutationAddRatingArgs = {
  position: RatingPosition;
  ratingId: Scalars['ID']['input'];
};


export type MutationAddRoleArgs = {
  organizationId: Scalars['ID']['input'];
  role: AppRole;
  userId: Scalars['ID']['input'];
};


export type MutationAddSponsoredOrganizationArgs = {
  data: AddSponsoredOrganizationInput;
};


export type MutationAddUserToOrganizationArgs = {
  organizationId: Scalars['ID']['input'];
  role: AppRole;
  userId: Scalars['ID']['input'];
};


export type MutationAdminDeactivateUserArgs = {
  reason: Scalars['LongUserInputString']['input'];
  userId: Scalars['ID']['input'];
};


export type MutationAdminReactivateUserArgs = {
  reason: Scalars['LongUserInputString']['input'];
  userId: Scalars['ID']['input'];
};


export type MutationAdminRemoveOrganizationEdlinkIntegrationArgs = {
  data: AdminRemoveOrganizationEdlinkIntegrationInput;
};


export type MutationAdminSaveOrganizationEdlinkIntegrationArgs = {
  data: AdminSaveOrganizationEdlinkIntegrationInput;
};


export type MutationAdminUpdateOrganizationEdlinkOnboardingArgs = {
  data: AdminUpdateOrganizationEdlinkOnboardingInput;
};


export type MutationAdminUpdateUserEmailArgs = {
  newEmail: Scalars['EmailAddress']['input'];
  reason: Scalars['LongUserInputString']['input'];
  userId: Scalars['ID']['input'];
};


export type MutationApproveAssignedActivitiesArgs = {
  ids: Array<Scalars['ID']['input']>;
};


export type MutationApproveProgramTimeEntryArgs = {
  data?: InputMaybe<ApproveTimeEntryInput>;
  entryId: Scalars['ID']['input'];
};


export type MutationArchiveRubricArgs = {
  rubricId: Scalars['ID']['input'];
};


export type MutationAssignInstructorToPlanArgs = {
  instructorId: Scalars['ID']['input'];
  planId: Scalars['ID']['input'];
};


export type MutationAssignLearnersToPlanArgs = {
  learnerIds: Array<Scalars['ID']['input']>;
  planId: Scalars['ID']['input'];
};


export type MutationAssignLearnersToProgramArgs = {
  data: AssignLearnersToProgramInput;
  learnerIds: Array<Scalars['ID']['input']>;
  programId: Scalars['ID']['input'];
};


export type MutationAssignLearnersToRapArgs = {
  data: RapDateInput;
  learnerIds: Array<Scalars['ID']['input']>;
  rapId: Scalars['ID']['input'];
};


export type MutationAssignUsersToLearnerCohortArgs = {
  id: Scalars['ID']['input'];
  users: Array<LearnerCohortAssignableUser>;
};


export type MutationAttachRubricToActivitiesArgs = {
  activityIds: Array<Scalars['ID']['input']>;
  rubricId: Scalars['ID']['input'];
};


export type MutationBatchTagUsersArgs = {
  data: BatchTagUsersInput;
};


export type MutationBatchUpdateActivityDueDatesArgs = {
  assignedActivityIds: Array<Scalars['ID']['input']>;
  dueDate: Scalars['DateTime']['input'];
};


export type MutationConfigureObservationTrackingArgs = {
  data: ConfigureObservationTrackingInput;
  programId: Scalars['ID']['input'];
};


export type MutationConfigureOrganizationForLearnerArgs = {
  organizationId: Scalars['ID']['input'];
};


export type MutationConfigureProgramTimeTrackingArgs = {
  data: ConfigureProgramTimeTrackingInput;
  programId: Scalars['ID']['input'];
};


export type MutationCreateAbsenceArgs = {
  data: CreateAbsenceInput;
};


export type MutationCreateActivityArgs = {
  data: CreateActivityInput;
};


export type MutationCreateActivityCompetencyTagArgs = {
  activityId: Scalars['ID']['input'];
  tagId: Scalars['ID']['input'];
};


export type MutationCreateActivityFileArgs = {
  activityId: Scalars['ID']['input'];
  data: CreateActivityFileData;
};


export type MutationCreateActivityFileDownloadUrlArgs = {
  filePath: Scalars['String']['input'];
};


export type MutationCreateActivityFilePreviewUrlArgs = {
  filePath: Scalars['String']['input'];
};


export type MutationCreateActivityFileUploadUrlArgs = {
  activityId: Scalars['ID']['input'];
  filePath: Scalars['String']['input'];
};


export type MutationCreateActivityLinkArgs = {
  activityId: Scalars['ID']['input'];
  data: CreateActivityLinkData;
};


export type MutationCreateActivityRequirementArgs = {
  data: CreateActivityRequirementInput;
};


export type MutationCreateActivityReviewArgs = {
  assignedActivityId: Scalars['ID']['input'];
};


export type MutationCreateAssignedActivityFileArgs = {
  assignedActivityId: Scalars['ID']['input'];
  data: CreateAssignedActivityFileData;
};


export type MutationCreateAssignedActivityFileDownloadArgs = {
  fileId: Scalars['ID']['input'];
};


export type MutationCreateAssignedActivityFileDownloadUrlArgs = {
  filePath: Scalars['String']['input'];
};


export type MutationCreateAssignedActivityFilePreviewUrlArgs = {
  filePath: Scalars['String']['input'];
};


export type MutationCreateAssignedActivityFileUploadUrlArgs = {
  assignedActivityId: Scalars['ID']['input'];
  filePath: Scalars['String']['input'];
};


export type MutationCreateAssignedActivityLinkArgs = {
  data: CreateAssignedActivityLinkData;
};


export type MutationCreateCollaborativeWithSponsorArgs = {
  data: CreateCollaborativeWithSponsorInput;
};


export type MutationCreateCompetencyTagArgs = {
  data: CreateCompetencyTagData;
  rapId: Scalars['ID']['input'];
};


export type MutationCreateCriterionCompetencyTagArgs = {
  criterionId: Scalars['ID']['input'];
  tagId: Scalars['ID']['input'];
};


export type MutationCreateFundingEntryArgs = {
  data: CreateFundingEntryInput;
};


export type MutationCreateLearnerCohortArgs = {
  data: CreateLearnerCohortData;
};


export type MutationCreateLevelArgs = {
  data: CreateLevelInput;
};


export type MutationCreateMultipleActivityLinksArgs = {
  activityIds: Array<Scalars['ID']['input']>;
  data: CreateMultipleActivityLinksData;
};


export type MutationCreateMultipleActivityRequirementsArgs = {
  activityIds: Array<Scalars['ID']['input']>;
  data: CreateMultipleActivityRequirementsInput;
};


export type MutationCreateOrganizationSupportContactArgs = {
  data: CreateOrganizationSupportContactInput;
};


export type MutationCreatePlanArgs = {
  data: CreatePlanInput;
};


export type MutationCreateProgramArgs = {
  data: CreateProgramInput;
};


export type MutationCreateUserArgs = {
  data: CreateUserInput;
};


export type MutationCreateUserEmailArgs = {
  email: Scalars['EmailAddress']['input'];
  userId: Scalars['ID']['input'];
};


export type MutationDeleteAbsenceArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteActivityArgs = {
  data: DeleteActivityInput;
};


export type MutationDeleteActivityCompetencyTagArgs = {
  activityId: Scalars['ID']['input'];
  tagId: Scalars['ID']['input'];
};


export type MutationDeleteActivityFileArgs = {
  activityFileId: Scalars['ID']['input'];
};


export type MutationDeleteActivityLinkArgs = {
  activityLinkId: Scalars['ID']['input'];
};


export type MutationDeleteAllActivityFilesArgs = {
  activityIds: Array<Scalars['ID']['input']>;
};


export type MutationDeleteAllActivityLinksArgs = {
  activityIds: Array<Scalars['ID']['input']>;
};


export type MutationDeleteAllContentTagsInProgramArgs = {
  programId: Scalars['ID']['input'];
  tagId: Scalars['ID']['input'];
};


export type MutationDeleteAssignedActivityFileArgs = {
  assignedActivityFileId: Scalars['ID']['input'];
};


export type MutationDeleteAssignedActivityLinkArgs = {
  assignedActivityLinkId: Scalars['ID']['input'];
};


export type MutationDeleteAssignedPlanArgs = {
  assignedPlanId: Scalars['ID']['input'];
};


export type MutationDeleteAssignedPlansArgs = {
  assignedPlanIds: Array<Scalars['ID']['input']>;
  planId: Scalars['ID']['input'];
};


export type MutationDeleteAssignedProgramArgs = {
  assignedProgramId: Scalars['ID']['input'];
};


export type MutationDeleteAssignedProgramsArgs = {
  assignedProgramIds: Array<Scalars['ID']['input']>;
  programId: Scalars['ID']['input'];
};


export type MutationDeleteAssignedRapArgs = {
  assignedRapId: Scalars['ID']['input'];
};


export type MutationDeleteCompetencyTagArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteCompetencyTagGroupArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteCriterionArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteCriterionCompetencyTagArgs = {
  criterionId: Scalars['ID']['input'];
  tagId: Scalars['ID']['input'];
};


export type MutationDeleteDraftRubricArgs = {
  rubricId: Scalars['ID']['input'];
};


export type MutationDeleteFundingEntryArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteLearnerCohortArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteLevelArgs = {
  data: DeleteLevelInput;
};


export type MutationDeleteMultipleActivityRequirementsArgs = {
  activityIds: Array<Scalars['ID']['input']>;
  data: DeleteMultipleActivityRequirementsInput;
};


export type MutationDeleteObservationTrackingArgs = {
  programId: Scalars['ID']['input'];
};


export type MutationDeleteOrganizationArgs = {
  data: DeleteOrganizationInput;
};


export type MutationDeleteOrganizationSupportContactArgs = {
  data: DeleteOrganizationSupportContactInput;
};


export type MutationDeletePlanArgs = {
  data: DeletePlanInput;
};


export type MutationDeleteProgramArgs = {
  data: DeleteProgramInput;
};


export type MutationDeleteProgramTimeEntryArgs = {
  entryId: Scalars['ID']['input'];
};


export type MutationDeleteRapArgs = {
  data: DeleteRapInput;
};


export type MutationDeleteRatingArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteTagArgs = {
  idToDelete: Scalars['ID']['input'];
};


export type MutationDeleteUserEmailArgs = {
  emailId: Scalars['ID']['input'];
};


export type MutationDeleteUserExternalIdArgs = {
  userId: Scalars['ID']['input'];
};


export type MutationDeleteWageEntryArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDetachRubricFromActivitiesArgs = {
  activityIds: Array<Scalars['ID']['input']>;
  rubricId?: InputMaybe<Scalars['ID']['input']>;
};


export type MutationDisableJoinCodeArgs = {
  data: DisablePlanJoinCodeInput;
};


export type MutationDiscardSelectedRatingsAndCommentsArgs = {
  activityReviewId: Scalars['ID']['input'];
};


export type MutationDispatchLtiAssociateActivityEventArgs = {
  activityId: Scalars['ID']['input'];
  ltiClassId: Scalars['String']['input'];
  ltiClassName: Scalars['String']['input'];
};


export type MutationDuplicateActivityArgs = {
  activityId: Scalars['ID']['input'];
};


export type MutationDuplicateLevelArgs = {
  assignToProgramLearners?: InputMaybe<Scalars['Boolean']['input']>;
  levelId: Scalars['ID']['input'];
};


export type MutationDuplicatePlanArgs = {
  assignToProgramLearners?: InputMaybe<Scalars['Boolean']['input']>;
  planId: Scalars['ID']['input'];
};


export type MutationDuplicateProgramArgs = {
  assignToProgramLearners?: InputMaybe<Scalars['Boolean']['input']>;
  programId: Scalars['ID']['input'];
};


export type MutationDuplicateRubricArgs = {
  rubricId: Scalars['ID']['input'];
};


export type MutationEnableJoinCodeArgs = {
  data: EnablePlanJoinCodeInput;
};


export type MutationEnterOrganizationAsAdminArgs = {
  organizationId: Scalars['ID']['input'];
};


export type MutationFavoriteLearnerCohortArgs = {
  id: Scalars['ID']['input'];
};


export type MutationJoinPlanArgs = {
  joinCode: Scalars['String']['input'];
};


export type MutationLinkCredEngineCredentialArgs = {
  data: CredEngineCredentialInput;
};


export type MutationLinkExternalCredentialArgs = {
  data: ExternalCredentialInput;
};


export type MutationPublishRapArgs = {
  rapId: Scalars['ID']['input'];
};


export type MutationPublishRubricArgs = {
  rubricId: Scalars['ID']['input'];
};


export type MutationReassignLearnersToProgramArgs = {
  assignedProgramIds: Array<Scalars['ID']['input']>;
  data: ReassignLearnersToProgramInput;
};


export type MutationRecordWageEntryForLearnerArgs = {
  data: RecordWageEntryInput;
};


export type MutationRemoveActivityRequirementArgs = {
  data: RemoveActivityRequirementInput;
};


export type MutationRemoveRoleByIdArgs = {
  id: Scalars['ID']['input'];
};


export type MutationRemoveSponsoredOrganizationArgs = {
  organizationId: Scalars['ID']['input'];
};


export type MutationRemoveUsersFromLearnerCohortArgs = {
  id: Scalars['ID']['input'];
  users: Array<LearnerCohortAssignableUser>;
};


export type MutationRenameTagArgs = {
  data: RenameTagInput;
  idToUpdate: Scalars['ID']['input'];
};


export type MutationReorderCriterionArgs = {
  ids: Array<Scalars['ID']['input']>;
};


export type MutationReorderRatingsArgs = {
  criterionId: Scalars['ID']['input'];
  ids: Array<Scalars['ID']['input']>;
};


export type MutationRequestEvaluationArgs = {
  data: RequestEvaluationData;
  programId: Scalars['ID']['input'];
};


export type MutationReturnAssignedActivitiesArgs = {
  ids: Array<Scalars['ID']['input']>;
};


export type MutationReturnProgramTimeEntryArgs = {
  data: ReturnTimeEntryInput;
  entryId: Scalars['ID']['input'];
};


export type MutationSaveAssignedActivityCommentArgs = {
  data: SaveAssignedActivityCommentData;
};


export type MutationSaveObservationDateArgs = {
  data: SaveObservationDateData;
};


export type MutationScoreObservationAttemptArgs = {
  data: ScoreObservationAttemptInput;
  id: Scalars['ID']['input'];
};


export type MutationSelectOrganizationRoleForAppUserArgs = {
  data: SelectOrganizationRoleForAppUserInput;
};


export type MutationSendEmailVerificationLinkArgs = {
  emailId: Scalars['ID']['input'];
};


export type MutationSendLtiAssignedActivityArgs = {
  assignedActivityId: Scalars['ID']['input'];
  ltiAssignmentId: Scalars['String']['input'];
  ltiClassId: Scalars['String']['input'];
  ltiData: Scalars['String']['input'];
};


export type MutationSetAssignedLevelUnlockedOnArgs = {
  assignedLevelId: Scalars['ID']['input'];
  data: SetAssignedLevelUnlockedOnData;
};


export type MutationSetCollaborativeSettingArgs = {
  setting: CollaborativeSettingsEnum;
  value: Scalars['Boolean']['input'];
};


export type MutationSetDueDateOnActivityArgs = {
  assignedActivityId: Scalars['ID']['input'];
  data: SetDueDateOnActivityData;
};


export type MutationSetLearnersEvaluatorsArgs = {
  learnersWithEvaluators: Array<LearnerEvaluatorsInput>;
};


export type MutationSetLevelLockSettingArgs = {
  data: SetLevelLockSettingInput;
  programId: Scalars['ID']['input'];
};


export type MutationSetRubricNaRatingConfigurationArgs = {
  naRatingConfiguration: SetRubricNaRatingConfigurationInput;
  rubricId: Scalars['ID']['input'];
};


export type MutationSetRubricNumericScoresConfigurationArgs = {
  numericScoresConfiguration: SetRubricNumericScoresConfigurationInput;
  rubricId: Scalars['ID']['input'];
};


export type MutationSubmitActivityArgs = {
  data: ActivitySubmissionData;
  id: Scalars['ID']['input'];
};


export type MutationSubmitLearnerWageEntryArgs = {
  data: SubmitWageEntryInput;
};


export type MutationSubmitProgramTimeEntryArgs = {
  data: SubmitTimeEntryInput;
  programId: Scalars['ID']['input'];
  relatedUserId?: InputMaybe<Scalars['ID']['input']>;
};


export type MutationSubmitScoredObservationAttemptsArgs = {
  data: SubmitScoredObservationAttemptsData;
  learnerId: Scalars['ID']['input'];
  programId: Scalars['ID']['input'];
};


export type MutationTagUserArgs = {
  data: TagUserInput;
};


export type MutationUnarchiveRubricArgs = {
  rubricId: Scalars['ID']['input'];
};


export type MutationUnassignInstructorToPlanArgs = {
  instructorId: Scalars['ID']['input'];
  planId: Scalars['ID']['input'];
};


export type MutationUnfavoriteLearnerCohortArgs = {
  id: Scalars['ID']['input'];
};


export type MutationUnlinkContentFromCredentialArgs = {
  associatedCredentialId: Scalars['ID']['input'];
};


export type MutationUnlockSkillsArgs = {
  learnerId: Scalars['ID']['input'];
  skillIds: Array<Scalars['ID']['input']>;
};


export type MutationUntagUserArgs = {
  data: UntagUserInput;
};


export type MutationUpdateAbsenceArgs = {
  data: UpdateAbsenceInput;
};


export type MutationUpdateActivityDescriptionArgs = {
  activityId: Scalars['ID']['input'];
  data: UpdateActivityDescriptionInput;
};


export type MutationUpdateActivityExternalIdArgs = {
  data: UpdateActivityExternalIdInput;
};


export type MutationUpdateActivityNameArgs = {
  data: UpdateActivityNameInput;
};


export type MutationUpdateActivityOrderArgs = {
  data: UpdateActivityOrderInput;
};


export type MutationUpdateActivityTargetRatingsArgs = {
  clear?: InputMaybe<Array<Scalars['ID']['input']>>;
  clearAll?: InputMaybe<Scalars['Boolean']['input']>;
  id: Scalars['ID']['input'];
  updates?: InputMaybe<Array<UpdateActivityTargetRatingsInput>>;
};


export type MutationUpdateAssignedActivityTimeSpentArgs = {
  data?: InputMaybe<UpdateAssignedActivityTimeSpentData>;
  id: Scalars['ID']['input'];
};


export type MutationUpdateAssignedLevelUnlockDatesArgs = {
  assignedLevelIds: Array<Scalars['ID']['input']>;
  levelId: Scalars['ID']['input'];
  unlockDate: Scalars['DateTime']['input'];
};


export type MutationUpdateAssignedProgramDateRangeArgs = {
  assignedProgramId: Scalars['ID']['input'];
  dateRange: UpdateAssignedProgramsDateRangeInput;
};


export type MutationUpdateAssignedProgramDatesArgs = {
  data: UpdateAssignedProgramDatesInput;
  learnerIds: Array<Scalars['ID']['input']>;
  programId: Scalars['ID']['input'];
};


export type MutationUpdateAssignedRapDatesArgs = {
  assignedRapId: Scalars['ID']['input'];
  data: RapDateInput;
};


export type MutationUpdateCompetencyTagArgs = {
  contentTagId: Scalars['ID']['input'];
  data: UpdateCompetencyTagData;
};


export type MutationUpdateCriterionArgs = {
  data: CriterionInput;
  id: Scalars['ID']['input'];
};


export type MutationUpdateCriterionExternalIdArgs = {
  criterionId: Scalars['ID']['input'];
  externalId: Scalars['String']['input'];
};


export type MutationUpdateDueDatesByAssignedLevelArgs = {
  assignedLevelId: Scalars['ID']['input'];
  dueDate: Scalars['DateTime']['input'];
};


export type MutationUpdateDueDatesByAssignedPlanArgs = {
  assignedPlanId: Scalars['ID']['input'];
  dueDate: Scalars['DateTime']['input'];
};


export type MutationUpdateFundingEntryArgs = {
  data: UpdateFundingEntryInput;
};


export type MutationUpdateLearnerCohortArgs = {
  data: UpdateLearnerCohortData;
  id: Scalars['ID']['input'];
};


export type MutationUpdateLearnerCohortsArgs = {
  cohorts: Array<Scalars['ID']['input']>;
  data: UpdateLearnerCohortsData;
};


export type MutationUpdateLevelDescriptionArgs = {
  data: UpdateLevelDescriptionInput;
};


export type MutationUpdateLevelExternalIdArgs = {
  data: UpdateLevelExternalIdInput;
};


export type MutationUpdateLevelNameArgs = {
  data: UpdateLevelNameInput;
};


export type MutationUpdateLevelOrderArgs = {
  data: UpdateLevelOrderInput;
};


export type MutationUpdateObservationTrackingArgs = {
  data: UpdateObservationTrackingInput;
  programId: Scalars['ID']['input'];
};


export type MutationUpdateOrganizationNameArgs = {
  data: UpdateOrganizationNameInput;
};


export type MutationUpdateOrganizationRoleClearedStatusArgs = {
  data: UpdateOrganizationRoleClearedStatusInput;
  organizationRoleId: Scalars['ID']['input'];
};


export type MutationUpdateOrganizationSupportContactArgs = {
  data: UpdateOrganizationSupportContactInput;
};


export type MutationUpdatePlanDescriptionArgs = {
  data: UpdatePlanDescriptionInput;
};


export type MutationUpdatePlanExternalIdArgs = {
  data: UpdatePlanExternalIdInput;
};


export type MutationUpdatePlanNameArgs = {
  data: UpdatePlanNameInput;
};


export type MutationUpdatePlanOrderArgs = {
  data: UpdatePlanOrderInput;
};


export type MutationUpdateProgramArgs = {
  data: UpdateProgramInput;
  programId: Scalars['ID']['input'];
};


export type MutationUpdateProgramAbsenceTrackingEnabledArgs = {
  data: UpdateProgramAbsenceTrackingEnabledInput;
};


export type MutationUpdateProgramCourseworkEnabledArgs = {
  data: UpdateProgramCourseworkEnabledInput;
};


export type MutationUpdateProgramDescriptionArgs = {
  data: UpdateProgramDescriptionInput;
};


export type MutationUpdateProgramExternalIdArgs = {
  data: UpdateProgramExternalIdInput;
};


export type MutationUpdateProgramNameArgs = {
  data: UpdateProgramNameInput;
};


export type MutationUpdateProgramOrderArgs = {
  data: UpdateProgramOrderInput;
};


export type MutationUpdateProgramStateArgs = {
  data: UpdateProgramStateInput;
};


export type MutationUpdateProgramTimeTrackingArgs = {
  data: UpdateProgramTimeTrackingInput;
  programId: Scalars['ID']['input'];
};


export type MutationUpdateRapArgs = {
  data: UpdateRapInput;
  rapId: Scalars['ID']['input'];
};


export type MutationUpdateRapOrderArgs = {
  data: UpdateRapOrderInput;
};


export type MutationUpdateRatingArgs = {
  id: Scalars['ID']['input'];
  ratingData: RatingInput;
};


export type MutationUpdateRubricExternalIdArgs = {
  externalId: Scalars['String']['input'];
  rubricId: Scalars['ID']['input'];
};


export type MutationUpdateRubricNameOrDescriptionArgs = {
  rubricId: Scalars['ID']['input'];
  rubricNameOrDescription: RubricNameOrDescriptionInput;
};


export type MutationUpdateUserArgs = {
  data: UpdateUserInput;
  userId: Scalars['ID']['input'];
};


export type MutationUpdateUserExternalIdArgs = {
  data: UpdateExternalIdInput;
  userId: Scalars['ID']['input'];
};


export type MutationUpdateUserPrimaryEmailArgs = {
  emailId: Scalars['ID']['input'];
};


export type MutationUpdateWageEntryArgs = {
  data: UpdateWageEntryInput;
};


export type MutationUpsertScoredCriterionArgs = {
  activityReviewId: Scalars['ID']['input'];
  criterionId: Scalars['ID']['input'];
  data: ScoredCriterionInput;
};


export type MutationWithdrawLearnersFromProgramArgs = {
  assignedProgramIds: Array<Scalars['ID']['input']>;
};

export type ObservationAttempt = ScoredObservationAttempt | UnScoredObservationAttempt;

export enum ObservationAttemptScore {
  Competent = 'COMPETENT',
  NotCompetent = 'NOT_COMPETENT',
  Score_1 = 'SCORE_1',
  Score_2 = 'SCORE_2',
  Score_3 = 'SCORE_3',
  Score_4 = 'SCORE_4',
  Score_5 = 'SCORE_5'
}

export type ObservationAttemptScoreModel = {
  __typename?: 'ObservationAttemptScoreModel';
  attemptId: Scalars['ID']['output'];
  label?: Maybe<Scalars['String']['output']>;
  value: ObservationAttemptScore;
};

export enum ObservationAttemptState {
  Scored = 'Scored',
  UnScored = 'UnScored'
}

export type ObservationCategory = ObservationCategoryInterface & {
  __typename?: 'ObservationCategory';
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  learnerId?: Maybe<Scalars['ID']['output']>;
  name: Scalars['StandardUserInputString']['output'];
  skills: Array<ObservationSkill>;
  updatedAt: Scalars['DateTime']['output'];
};

export type ObservationCategoryAddition = {
  name: Scalars['StandardUserInputString']['input'];
  skills: Array<ObservationSkillAddition>;
};

export type ObservationCategoryChanges = {
  add?: InputMaybe<Array<ObservationCategoryAddition>>;
  remove?: InputMaybe<Array<Removal>>;
  update?: InputMaybe<Array<ObservationCategoryUpdate>>;
};

export type ObservationCategoryInterface = {
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  learnerId?: Maybe<Scalars['ID']['output']>;
  name: Scalars['StandardUserInputString']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type ObservationCategoryUpdate = {
  id: Scalars['ID']['input'];
  name?: InputMaybe<Scalars['StandardUserInputString']['input']>;
  skills?: InputMaybe<ObservationSkillChanges>;
};

export type ObservationCustomField = {
  __typename?: 'ObservationCustomField';
  createdAt: Scalars['DateTime']['output'];
  dropdownOptions: Array<Scalars['StandardUserInputString']['output']>;
  id: Scalars['ID']['output'];
  label: Scalars['StandardUserInputString']['output'];
  type: ObservationCustomFieldType;
  updatedAt: Scalars['DateTime']['output'];
};

export type ObservationCustomFieldAddition = {
  dropdownOptions: Array<Scalars['StandardUserInputString']['input']>;
  label: Scalars['StandardUserInputString']['input'];
  type: ObservationCustomFieldType;
};

export type ObservationCustomFieldChanges = {
  add?: InputMaybe<Array<ObservationCustomFieldAddition>>;
  remove?: InputMaybe<Array<Removal>>;
  update?: InputMaybe<Array<ObservationCustomFieldUpdate>>;
};

export enum ObservationCustomFieldType {
  Dropdown = 'DROPDOWN'
}

export type ObservationCustomFieldUpdate = {
  dropdownOptions?: InputMaybe<Array<Scalars['StandardUserInputString']['input']>>;
  id: Scalars['ID']['input'];
  label?: InputMaybe<Scalars['StandardUserInputString']['input']>;
  type?: InputMaybe<ObservationCustomFieldType>;
};

export type ObservationCustomFieldValue = {
  __typename?: 'ObservationCustomFieldValue';
  customField: ObservationCustomField;
  id: Scalars['ID']['output'];
  value: Scalars['String']['output'];
};

export enum ObservationScoringMethod {
  PassFail = 'PASS_FAIL',
  Scale_3 = 'SCALE_3',
  Scale_4 = 'SCALE_4',
  Scale_5 = 'SCALE_5'
}

export type ObservationSkill = SkillInterface & {
  __typename?: 'ObservationSkill';
  configuration: ProgramObservationTracking;
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  learnerId?: Maybe<Scalars['ID']['output']>;
  minimumSuccessfulAttempts?: Maybe<Scalars['MinimumSuccessfulAttempts']['output']>;
  name: Scalars['LongUserInputString']['output'];
  program: Program;
  repeatable: Scalars['Boolean']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type ObservationSkillAddition = {
  minimumSuccessfulAttempts: Scalars['MinimumSuccessfulAttempts']['input'];
  name: Scalars['LongUserInputString']['input'];
  repeatable: Scalars['Boolean']['input'];
};

export type ObservationSkillChanges = {
  add?: InputMaybe<Array<ObservationSkillAddition>>;
  remove?: InputMaybe<Array<Removal>>;
  update?: InputMaybe<Array<ObservationSkillUpdate>>;
};

export enum ObservationSkillState {
  Completed = 'Completed',
  Pending = 'Pending',
  Ready = 'Ready'
}

export type ObservationSkillUpdate = {
  id: Scalars['ID']['input'];
  minimumSuccessfulAttempts?: InputMaybe<Scalars['MinimumSuccessfulAttempts']['input']>;
  name?: InputMaybe<Scalars['LongUserInputString']['input']>;
  repeatable?: InputMaybe<Scalars['Boolean']['input']>;
};

export type Occupation = {
  __typename?: 'Occupation';
  code: Scalars['OccupationCode']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

export type OccupationsFilters = {
  search?: InputMaybe<Scalars['SanitizedString']['input']>;
};

export type Organization = {
  __typename?: 'Organization';
  /** Returns a comma-joined list of admin emails or an empty string if the list of admins is empty. */
  adminEmails: Scalars['String']['output'];
  /**
   * Returns the collaborative for this organization.
   *       System Admin Organizations will return null due to not having a collaborative.
   */
  collaborative?: Maybe<Collaborative>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  /** Support contacts for this organization */
  supportContacts: Array<OrganizationSupportContact>;
  type: OrganizationType;
};

export type OrganizationEvaluatorsInput = {
  organizationId: Scalars['ID']['input'];
};

export type OrganizationFilterBy = {
  name?: InputMaybe<Scalars['String']['input']>;
};

export type OrganizationOrderBy = {
  name?: InputMaybe<SortOrder>;
  type?: InputMaybe<SortOrder>;
};

export type OrganizationRole = {
  __typename?: 'OrganizationRole';
  cleared?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['ID']['output'];
  organization: Organization;
  role: AppRole;
  user: AppUser;
};

export type OrganizationRoleFilter = {
  every?: InputMaybe<OrganizationRoleWhereInput>;
  none?: InputMaybe<OrganizationRoleWhereInput>;
  some?: InputMaybe<OrganizationRoleWhereInput>;
};

export type OrganizationRoleWhereInput = {
  AND?: InputMaybe<Array<OrganizationRoleWhereInput>>;
  NOT?: InputMaybe<Array<OrganizationRoleWhereInput>>;
  OR?: InputMaybe<Array<OrganizationRoleWhereInput>>;
  learner?: InputMaybe<UserWhereInput>;
  learnerId?: InputMaybe<StringFilter>;
  organizationId?: InputMaybe<StringFilter>;
  role?: InputMaybe<AppRole>;
};

export type OrganizationSupportContact = {
  __typename?: 'OrganizationSupportContact';
  email: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  title?: Maybe<Scalars['String']['output']>;
};

export enum OrganizationType {
  EducationProvider = 'EDUCATION_PROVIDER',
  Employer = 'EMPLOYER',
  Sponsor = 'SPONSOR',
  SystemAdmin = 'SYSTEM_ADMIN'
}

/** Pagination Arguments */
export type PaginationArgs = {
  /** The current page of results being requested. */
  page: Scalars['Int']['input'];
  /** The number of results to be returned per page. */
  pageSize: Scalars['Int']['input'];
};

/** Represents the number of items pending evaluator approval for various models in the application where learner submission and evaluator approval is applicable. */
export type PendingApprovalsCount = {
  __typename?: 'PendingApprovalsCount';
  /** Returns a the number of assigned activities pending approval. This value is different depending on the user role. */
  activities: Scalars['Int']['output'];
  /** Returns the number of observation attempts pending approval for all learners that the currently logged in evaluator can evaluate. */
  observationAttempts: Scalars['Int']['output'];
  /** Returns a the number of time entries pending approval. */
  timeEntries: Scalars['Int']['output'];
};

export enum PendingObservationAttemptSortFieldEnum {
  CreatedAt = 'createdAt',
  PerformedAt = 'performedAt'
}

export type PendingObservationAttemptSortOrderBy = {
  field: PendingObservationAttemptSortFieldEnum;
  sortOrder: SortOrder;
};

export type PendingObservationAttemptsFilters = {
  learnerId: Array<Scalars['ID']['input']>;
};

/** Filters that can be used for querying learners associated with observation attempts that are pending approval. */
export type PendingObservationAttemptsLearnersFilters = {
  /** A search term to filter the learners by. */
  search?: InputMaybe<StringFilter>;
};

export type PendingProgramTimeEntriesFilters = {
  relatedUserId: Array<Scalars['ID']['input']>;
};

/** Filters that can be used for querying learners associated with time entries that are pending approval. */
export type PendingTimeEntriesLearnersFilters = {
  /** A search term to filter the learners by. */
  search?: InputMaybe<StringFilter>;
};

export enum PendingTimeEntrySortFieldEnum {
  DateKey = 'dateKey',
  SubmittedAt = 'submittedAt'
}

export type PendingTimeEntrySortOrderBy = {
  field: PendingTimeEntrySortFieldEnum;
  sortOrder: SortOrder;
};

export type Plan = {
  __typename?: 'Plan';
  /** Instructors assigned to this plan */
  activities: Array<Activity>;
  /** Instructors assigned to this plan */
  assignedInstructors: Array<UserProfile>;
  /** The LER credential associated with this plan */
  associatedCredential?: Maybe<AssociatedCredential>;
  description?: Maybe<Scalars['String']['output']>;
  displayOrder: Scalars['Int']['output'];
  externalId?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  joinCode?: Maybe<Scalars['String']['output']>;
  level: Level;
  levelId: Scalars['String']['output'];
  name: Scalars['String']['output'];
  /** The organization id that this plan belongs to. */
  organizationId: Scalars['ID']['output'];
  /** Program this plan is a part of */
  program: Program;
};

export type PlanInstructorFilter = {
  every?: InputMaybe<PlanInstructorWhereInput>;
  none?: InputMaybe<PlanInstructorWhereInput>;
  some?: InputMaybe<PlanInstructorWhereInput>;
};

export type PlanInstructorWhereInput = {
  instructorId?: InputMaybe<StringFilter>;
  planId?: InputMaybe<StringFilter>;
};

export type PlanOrderBy = {
  name?: InputMaybe<SortOrder>;
};

export type Program = {
  __typename?: 'Program';
  absenceTrackingEnabled: Scalars['Boolean']['output'];
  /** Pulls the relevant activities from the program, filtered by level and or plan */
  activitiesByProgramContentId: Array<Activity>;
  /** Activities in the program which have the given tag applied. */
  activitiesWithAppliedTag: Array<Activity>;
  activityCountByProgramContentId: Scalars['Int']['output'];
  /** The LER credential associated with this program */
  associatedCredential?: Maybe<AssociatedCredential>;
  courseworkEnabled: Scalars['Boolean']['output'];
  description?: Maybe<Scalars['String']['output']>;
  displayOrder: Scalars['Int']['output'];
  externalId?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  industry?: Maybe<Industry>;
  levelLockSettingEnabled: Scalars['Boolean']['output'];
  /** Returns this program's levels. If you are an instructor they are filtered to be only the levels assigned to that instructor. */
  levels: Array<Level>;
  name: Scalars['String']['output'];
  /** Observation tracking configuration information for the program. Will be null if the program is not configured for observation tracking. */
  observationTracking?: Maybe<ProgramObservationTracking>;
  occupation?: Maybe<Occupation>;
  organizationId: Scalars['String']['output'];
  /** The name of the organization which owns this program. */
  organizationName: Scalars['String']['output'];
  /** The organization type of the organization which owns this program */
  organizationType: OrganizationType;
  registeredApprenticeshipProgram?: Maybe<RegisteredApprenticeshipProgram>;
  registeredApprenticeshipProgramId?: Maybe<Scalars['String']['output']>;
  state: ProgramState;
  timeSchedule?: Maybe<TimeSchedule>;
  /** Time tracking configuration information for the program.  Will be null if the program is not configured for time tracking. */
  trackedTime?: Maybe<ProgramTrackedTime>;
};


export type ProgramActivitiesByProgramContentIdArgs = {
  filterBy?: InputMaybe<Array<ActivityFilterBy>>;
  levelIds: Array<Scalars['ID']['input']>;
  orderBy?: InputMaybe<ActivityOrderBy>;
  pagination: PaginationArgs;
  planIds: Array<Scalars['ID']['input']>;
};


export type ProgramActivitiesWithAppliedTagArgs = {
  tagId: Scalars['ID']['input'];
};


export type ProgramActivityCountByProgramContentIdArgs = {
  filterBy?: InputMaybe<Array<ActivityFilterBy>>;
  levelIds: Array<Scalars['ID']['input']>;
  planIds: Array<Scalars['ID']['input']>;
};

export type ProgramObservationTracking = {
  __typename?: 'ProgramObservationTracking';
  /** The observation categories with their nested skills. Returns null if the program was configured with root-level skills rather than categories. */
  categories?: Maybe<Array<ObservationCategory>>;
  /** The custom fields for observation tracking. */
  customFields: Array<ObservationCustomField>;
  /** Custom labels for each score level in scale-based scoring methods. */
  customLabels: Array<Scalars['String']['output']>;
  /** Indicates whether there are tracked observations or activity for evaluators, instructors, or learners. This determines whether substantial or non-substantial updates are allowed when modifying the configuration. */
  hasTrackedObservations: Scalars['Boolean']['output'];
  /** Indicates whether the skills are nested under categories or at the root level. */
  isConfiguredWithCategories: Scalars['Boolean']['output'];
  /** Whether observations require pre-approval before learners can request them. */
  isPreApprovalEnabled: Scalars['Boolean']['output'];
  programId: Scalars['ID']['output'];
  scoringMethod: ObservationScoringMethod;
  /** The uncategorized observation skills for this program. Returns null if the program was configured with categories rather than root-level skills. */
  skills?: Maybe<Array<ObservationSkill>>;
  /** The target score that learners must achieve for scale-based scoring methods. Null for pass/fail scoring. */
  targetScore?: Maybe<Scalars['TargetScore']['output']>;
};

export type ProgramProgress = {
  __typename?: 'ProgramProgress';
  approvedActivities: Scalars['Int']['output'];
  approvedTimeSpent: Scalars['Int']['output'];
  dueActivities: Scalars['Int']['output'];
  overdueActivities: Scalars['Int']['output'];
  programEndDate: Scalars['DateTime']['output'];
  programStartDate: Scalars['DateTime']['output'];
  submittedActivities: Scalars['Int']['output'];
  totalActivities: Scalars['Int']['output'];
};

export type ProgramProgressAggregate = {
  __typename?: 'ProgramProgressAggregate';
  assignedLevelId: Scalars['String']['output'];
  assignedPlanId: Scalars['String']['output'];
  assignedProgramId: Scalars['String']['output'];
  levelPercentComplete: Scalars['Float']['output'];
  planPercentComplete: Scalars['Float']['output'];
  programPercentComplete: Scalars['Float']['output'];
};

export enum ProgramState {
  Active = 'ACTIVE',
  Archived = 'ARCHIVED'
}

export type ProgramTimeEntry = {
  __typename?: 'ProgramTimeEntry';
  /** The evaluators available to this learner for time tracker submissions in this program's organization. */
  availableEvaluators: Array<UserProfile>;
  /** When the time entry was created. */
  createdAt: Scalars['DateTime']['output'];
  /** The evaluators assigned to review the most recent submitted review of this time entry, ordered alphabetically by name. Only includes reviewers who are still active and still assigned to evaluate this learner. Empty list when the entry routes to all evaluators (no specific selection was made). */
  currentReviewers: Array<UserProfile>;
  /** A unique key representing the specific day/month/year or month/year of the entry. */
  dateKey: Scalars['DateKey']['output'];
  id: Scalars['ID']['output'];
  /** The items associated with this time entry. */
  items: Array<CompleteProgramTimeEntryItem>;
  /** The timestamp of when the most recent submitted review was created for this time entry. */
  lastSubmittedAt: Scalars['DateTime']['output'];
  /** The most recent review of the entry. A saved entry always has at least its submission review; templates loaded from the API expose no reviews. */
  latestReview: ProgramTimeEntryReview;
  /** The program associated with this time entry. */
  program: TimeTrackedProgram;
  programId: Scalars['String']['output'];
  /** The user who this time entry is submitted for, usually a learner. */
  relatedUser: UserProfile;
  /** The ID of the user who this time entry is submitted for, usually a learner. */
  relatedUserId: Scalars['ID']['output'];
  /** The reviews associated with this time entry. */
  reviews: Array<ProgramTimeEntryReview>;
  /** The review state of the time entry, which is derived from the most recent review. */
  state: TimeEntryReviewState;
  /** The comment associated with the most recently submitted review of the time entry. */
  submittedComment?: Maybe<Scalars['String']['output']>;
  /** The total number of minutes logged in this time entry. */
  totalMinutes: Scalars['Int']['output'];
  /** When the time entry was last updated. */
  updatedAt: Scalars['DateTime']['output'];
};

export type ProgramTimeEntryItem = {
  __typename?: 'ProgramTimeEntryItem';
  /** The total number of minutes logged for the item associated with this entry item, across all entries, excluding this entry item. */
  accumulatedOtherTime: Scalars['Int']['output'];
  /** When the time entry item was created. */
  createdAt: Scalars['DateTime']['output'];
  entryId: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  /** The time item associated with this entry item. */
  item: ProgramTimeItem;
  /** The ID of the time item associated with this entry item. */
  itemId: Scalars['ID']['output'];
  minutes: Scalars['Int']['output'];
  /** The ID of the program associated with this entry item. */
  programId: Scalars['ID']['output'];
  /** The ID of the user that is associated with the time entry that contains this entry item. */
  relatedUserId: Scalars['ID']['output'];
  /** When the time entry item was last updated. */
  updatedAt: Scalars['DateTime']['output'];
};

export type ProgramTimeEntryReview = {
  __typename?: 'ProgramTimeEntryReview';
  comment?: Maybe<Scalars['String']['output']>;
  /** When the time entry review was created. */
  createdAt: Scalars['DateTime']['output'];
  /** Who created the time entry review. */
  createdBy: UserProfile;
  entryId: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  /** The evaluators assigned to review this submission, ordered alphabetically by name. */
  reviewers: Array<UserProfile>;
  state: TimeEntryReviewState;
};

export type ProgramTimeItem = {
  __typename?: 'ProgramTimeItem';
  /** When the time item was created */
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  programId: Scalars['String']['output'];
  target: Scalars['Int']['output'];
  targetMinutes: Scalars['Int']['output'];
  /** When the time item was last updated */
  updatedAt: Scalars['DateTime']['output'];
};

export type ProgramTimeItemInput = {
  name: Scalars['ProgramTimeItemName']['input'];
  target: Scalars['PositiveInteger']['input'];
};

export type ProgramTrackedTime = {
  __typename?: 'ProgramTrackedTime';
  /** Indicates whether or not any learners have submitted time entries for this program. */
  hasSubmittedEntries: Scalars['Boolean']['output'];
  programId: Scalars['ID']['output'];
  /** The time items configured for this program */
  timeItems: Array<ProgramTimeItem>;
  timeSchedule: TimeSchedule;
  /** Total target hours for a program's time items */
  totalTargetHours: Scalars['Int']['output'];
};

export type ProgramWhereInput = {
  description?: InputMaybe<StringFilter>;
  displayOrder?: InputMaybe<IntFilter>;
  id?: InputMaybe<StringFilter>;
  name?: InputMaybe<StringFilter>;
  organizationId?: InputMaybe<Scalars['String']['input']>;
};

export type Query = {
  __typename?: 'Query';
  /** Get data for an activity by ID */
  activity: Activity;
  /** Gets unique activity review by the assigned activity submission. Returns null if a review does not exist. */
  activityReviewByAssignedActivitySubmission?: Maybe<ActivityReview>;
  /** Every organization in the system together with its Edlink connection data. Ordering is fixed by name and then id so pages stay stable. SystemAdmin only. */
  adminEdlinkOrganizations: Array<AdminEdlinkOrganization>;
  /** Total match count for `adminEdlinkOrganizations`. Same filter and same gating as the list query. SystemAdmin only. */
  adminEdlinkOrganizationsCount: Scalars['Int']['output'];
  /** Cross-org user search by first name, last name, or email substring. SystemAdmin only. */
  adminSearchUsers: Array<AdminUserSearchResult>;
  /** Total match count for `adminSearchUsers`. Same gating as the search query. */
  adminSearchUsersCount: Scalars['Int']['output'];
  /** Returns up to 100 admin-initiated email changes for the given user, newest first. SystemAdmin only. */
  adminUserEmailChangeHistory: Array<AdminEmailChangeRecord>;
  /** Gets a list of assigned activities for a given activity. */
  assignedActivitiesByActivityId: Array<AssignedActivity>;
  /** Gets a count of assigned activities for a given activity. */
  assignedActivitiesByActivityIdCount: Scalars['Int']['output'];
  /** Returns a list of activities pending evaluation. This list is different depending on the user role. */
  assignedActivitiesPendingApproval: Array<AssignedActivity>;
  /** Gets a list of assigned activities for a learner tagged with the given tag. */
  assignedActivitiesWithCompetencyTag: Array<AssignedActivity>;
  /** Gets an assigned activity by the provided ID */
  assignedActivity: AssignedActivity;
  /** Gets an assigned level by the provided ID */
  assignedLevel: AssignedLevel;
  /** Returns a list of learners assigned to the provided level. */
  assignedLevelsByLevelId: Array<AssignedLevel>;
  /** Returns the count of learners assigned to the provided level. */
  assignedLevelsByLevelIdCount: Scalars['Int']['output'];
  /** Gets an assigned plan by the provided ID. */
  assignedPlan: AssignedPlan;
  /** Returns a list of learners assigned to the provided level. */
  assignedPlansByPlanId: Array<AssignedPlan>;
  /** Returns the count of learners assigned to the provided plan. */
  assignedPlansByPlanIdCount: Scalars['Int']['output'];
  /** Returns a list of assigned plans that have activities with related content. */
  assignedPlansWithStartedActivities: Array<AssignedPlan>;
  /** Gets an assigned program by the provided ID. Checks that the user is assigned to the program. */
  assignedProgram: AssignedProgram;
  /** Get programs for the provide learner id. */
  assignedProgramsByLearnerId: Array<AssignedProgram>;
  /** Get the count of assigned programs for the provide learner id. */
  assignedProgramsByLearnerIdCount: Scalars['Int']['output'];
  /** Get a list of assigned programs in the current organization for the given learner where one or more activities have the provided tag. */
  assignedProgramsByLearnerIdWithAppliedCompetencyTag: Array<AssignedProgram>;
  /** Get programs for the provided learner id. */
  assignedProgramsByProgramId: Array<AssignedProgram>;
  /** Get a count of programs for the provide learner id. Used for the pagination. */
  assignedProgramsByProgramIdCount: Scalars['Int']['output'];
  /** Returns programs the user is assigned to, with absence tracking enabled */
  assignedProgramsWithAbsenceTracking: Array<AssignedProgram>;
  /** Returns a list of assigned programs that have activities with related content. */
  assignedProgramsWithStartedActivities: Array<AssignedProgram>;
  /** Gets the current user's assignedProgram for the given RAP ID. Only available to learners. */
  assignedRapProgram?: Maybe<AssignedProgram>;
  /** Gets the current user's RAPs. Only available to learners. */
  assignedRaps: Array<RegisteredApprenticeshipProgram>;
  /** Returns assigned RAPs for a given RAP ID. */
  assignedRapsByRapId: Array<AssignedRap>;
  /** Returns the number of assigned RAPs for a given RAP ID. */
  assignedRapsByRapIdCount: Scalars['Int']['output'];
  /** The actively logged in and authenticated user. */
  authenticatedUser: AuthenticatedUser;
  /** Returns the evaluators that a learner is allowed to select from when requesting an evaluation via an observation attempt. */
  availableAttemptEvaluators: Array<UserProfile>;
  /** Returns a user's avatar. Authorized for any user in the caller's collaborative, so avatars can be rendered in contexts (e.g. a learner viewing their reviewers) where the full profile is not accessible. */
  avatar: Avatar;
  /**
   * Get RAPs for an organization in a collaborative.
   *   Filter on published or unpublished RAPs.
   */
  collaborativeRaps: Array<RegisteredApprenticeshipProgram>;
  collaborativeUsers: Array<UserProfile>;
  collaborativeUsersCount: Scalars['Int']['output'];
  /** Returns the competency tag groups associated with a given RAP by ID. */
  competencyTagGroupsByRapId: Array<ContentTagGroup>;
  /** Returns the total count of competency tag groups associated with a given RAP. */
  competencyTagGroupsByRapIdCount: Scalars['Int']['output'];
  /** Returns competency tags for a given tag group. */
  competencyTagsByGroupId: Array<ContentTag>;
  /** Returns Collaborative currently being accessed by a sponsor admin. */
  currentCollaborative: Collaborative;
  /** Get a draft activity review created by the current user (if exists) for assigned activity. */
  draftActivityReviewByAssignedActivity?: Maybe<ActivityReview>;
  /** Exports all absence records matching the filters as CSV (base64). Columns: Date, Learner First Name, Learner Last Name, Program, Duration, Reason, Comment. */
  exportAbsencesReport: Scalars['String']['output'];
  /** Fetches learner cohorts favorited by the currently active user. */
  favoritedLearnerCohorts: Array<LearnerCohort>;
  /** Get absence history for the current learner with optional program filter */
  getAbsenceHistory: Array<Absence>;
  /** Get absence history for a specific learner (admin only) */
  getAbsenceHistoryForLearner: Array<Absence>;
  /** Admin report of absences filtered by program and/or learner within the selected organization, ordered by date desc. */
  getAbsencesReport: Array<Absence>;
  /** Returns the total count of absences matching the filter criteria */
  getAbsencesReportCount: Scalars['Int']['output'];
  /** Returns a list of organizations in the collaborative by the provided sponsor org */
  getCollaborativeOrgsBySponsorOrg: Array<Organization>;
  /** Fetches credential data from credential engine by CTID */
  getCredentialEngineCredential: CredentialEngineCredential;
  /** Returns a list of instructors for the education provider. Returns an empty list if the user is not an EP admin. Used by EP admins to get a list of available instructors for assignment to a plan. Only EP admins do this work. */
  getEducationProviderInstructors: Array<UserProfile>;
  /** Get all evaluators in the organization or collaborative. */
  getEvaluators: Array<UserProfile>;
  /** Get a paginated list of collaborative learners assigned to the evaluator. */
  getEvaluatorsAssignedLearners: Array<LearnerProfile>;
  /** Returns the number of learners in the collaborative assigned to the evaluator */
  getEvaluatorsAssignedLearnersCount: Scalars['Int']['output'];
  /** Returns a learner profile by learner id. */
  getLearnerProfile: LearnerProfile;
  /** Get all learners in the organization or collaborative. If a list of IDs is provided return those learners. */
  getLearners: Array<LearnerProfile>;
  /** Get a paginated list of collaborative evaluators assigned to the learner. */
  getLearnersAssignedEvaluators: Array<UserProfile>;
  /** Returns the number of learners in the collaborative assigned to the evaluator */
  getLearnersAssignedEvaluatorsCount: Scalars['Int']['output'];
  /** Get data for organization learners */
  getLearnersAvailableForAssignment: Array<LearnerProfile>;
  /** Get data for organization learners */
  getLearnersAvailableForAssignmentCount: Scalars['Int']['output'];
  /** Get all learners in the organization or collaborative. If a list of IDs is provided return those learners. */
  getLearnersCount: Scalars['Int']['output'];
  /** Get learners for a given plan ready to be assigned to that plan. */
  getLearnersForPlanAssignment: Array<UserProfile>;
  /** Get data for organization learners */
  getLearnersForPlanAssignmentCount: Scalars['Int']['output'];
  /** Returns a list of possible organizations based on provided type. */
  getLearnersPossibleRelationsByType: Array<Organization>;
  /** Returns a user profile. If no id is provided, the profile of the authenticated user is returned. */
  getProfile: UserProfile;
  /** Fetches data for a single learner cohort. */
  learnerCohort: LearnerCohort;
  /** Fetches the available learners, facilitators or instructors for the given cohort. */
  learnerCohortAvailableUsers: Array<UserProfile>;
  /** Fetches the learners for the given cohort. */
  learnerCohortLearners: Array<UserProfile>;
  /** Fetches the learners, facilitators or instructors for the given cohort. */
  learnerCohortUsers: Array<UserProfile>;
  /** Fetches learner cohorts. */
  learnerCohorts: Array<LearnerCohort>;
  /** All wage entries for the given learner, most-recent effective date first. Admins only see entries whose employer is in the admin's active collaborative; learners viewing their own history see all entries. */
  learnerWageHistory: Array<LearnerWageEntry>;
  /** Returns a list of learners that are associated with assigned activities pending approval. */
  learnersWithAssignedActivitiesPendingApproval: Array<AppUser>;
  /** Returns a level given its ID. */
  level: Level;
  /** Gets an assigned activity by the provided learner email and activity id */
  ltiAssignedActivityByLearnerEmailAndActivityId: AssignedActivity;
  /** This query provides the Metabase content iframe URL for the current user and role */
  metabaseIframeUrl?: Maybe<Scalars['String']['output']>;
  /** This query provides the Metabase content iframe URL for a specific learner */
  metabaseIframeUrlByLearnerId?: Maybe<Scalars['String']['output']>;
  /** Get all absences for the current user */
  myAbsences: Array<Absence>;
  /** The evaluators associated with this user. */
  myAssignedEvaluators: Array<UserProfile>;
  /** The education provider associated with this user in the current collaborative */
  myEducationProvider?: Maybe<Organization>;
  /** The employer associated with this user in the current collaborative */
  myEmployer?: Maybe<Organization>;
  /** Get learners associated to the user. The returned list is different depending on the user role. These are learners that the user can evaluate. */
  myLearners: Array<LearnerProfile>;
  /** Returns a list of organizations. */
  myOrganizations: Array<Organization>;
  /** The learners associated with this evaluator user who have a cleared status of false. */
  notClearedLearnersForEvaluator: Array<LearnerProfile>;
  occupations: Array<Occupation>;
  /** Get evaluators for an organization */
  organizationEvaluators: Array<AppUser>;
  /** Get programs for a user's organization and role. */
  organizationPrograms: Array<Program>;
  /** Get a list of programs in the current organization where one or more activities have the provided tag. */
  organizationProgramsWithAppliedCompetencyTag: Array<Program>;
  /** Get a list of all the organization's rubrics. Uses the current user's selected organization to filter on. Only available to admins. */
  organizationRubrics: Array<Rubric>;
  /** Query Tags in an organization */
  organizationTags: Array<UserTag>;
  organizationUsers: Array<UserProfile>;
  organizationUsersCount: Scalars['Int']['output'];
  /** Get a list of assigned programs in other collaborative organizations for the given learner where one or more activities have the provided tag. Only available to sponsor admins. */
  otherCollaborativeOrgAssignedProgramsByLearnerIdWithAppliedCompetencyTag: Array<AssignedProgram>;
  /** Get a list of programs in the collaborative but not in the current organization where one or more activities have the provided tag. */
  otherCollaborativeOrgProgramsWithAppliedCompetencyTag: Array<Program>;
  /** Returns all the programs in the collaborative not owned by the sponsor. Only available to sponsor admins. */
  otherOrgsInCollaborativesPrograms: Array<Program>;
  /** Returns the number of items pending evaluator approval for various models in the application where learner submission and evaluator approval is applicable. */
  pendingApprovalsCount: PendingApprovalsCount;
  /** Returns the observation attempt that is in a pending state for the specified ID. */
  pendingObservationAttempt: ObservationAttempt;
  /** Returns the observation attempts that are in a pending state for all learners that the currently logged in evaluator can evaluate. */
  pendingObservationAttempts: Array<UnScoredObservationAttempt>;
  /** Returns the learners that the currently logged in evaluator can evaluate who have observation attempts that are in a pending state. */
  pendingObservationAttemptsLearners: Array<UserProfile>;
  /** Returns the time entries that are in a pending state for all learners that the currently logged in evaluator can evaluate. */
  pendingProgramTimeEntries: Array<ProgramTimeEntry>;
  /** Returns the learners that the currently logged in evaluator can evaluate who have time entries that are in a pending state. */
  pendingProgramTimeEntriesLearners: Array<UserProfile>;
  /** Get a plan by ID. */
  plan: Plan;
  /** Returns plans assigned to an instructor. */
  plansAssignedToInstructor: Array<Plan>;
  /** Returns the count of plans assigned to an instructor. */
  plansAssignedToInstructorCount: Scalars['Int']['output'];
  /** Get a program by its ID */
  program: Program;
  /** Returns a list of learners assigned to the provided program. */
  programAssignedLearners: Array<UserProfile>;
  /** Get progress details for a program, including activity counts and other metrics. */
  programProgress: ProgramProgress;
  /**
   * Returns a list of progress aggregate details for a program,
   *     including activity counts and other metrics.
   */
  programProgressAggregate: Array<ProgramProgressAggregate>;
  /** Returns active programs for the current organization, plus collaborative programs for sponsor admins. Intended for CSV upload reference lookups. */
  programReferences: Array<Program>;
  /** Returns all previously submitted time entries for a given program, for the current user if they are a learner or the learner associated with the provided ID. */
  programTimeEntries: Array<ProgramTimeEntry>;
  /** Returns the previously submitted or empty time entry for a given program and date, for the current user if they are a learner or the learner associated with the provided ID. */
  programTimeEntry: CompleteProgramTimeEntry;
  /** Returns the program time entry associated with the provided ID. */
  programTimeEntryById: ProgramTimeEntry;
  /** Get data for a specific RAP by ID */
  rap: RegisteredApprenticeshipProgram;
  /** Gets list of 10 most recently evaluated activities sorted by most recent to least recent. */
  recentlyEvaluatedActivities: Array<AssignedActivity>;
  /** Returns all previously submitted time entries for the current learner across programs where they are a related user. */
  relatedUserTimeEntries: Array<ProgramTimeEntry>;
  /** Get data for a specific rubric by ID. Throws an error if the rubric is not found. */
  rubricById: Rubric;
  /** Get a list of  rubrics based on filters and pagination. */
  rubrics: Array<Rubric>;
  /** Returns a list of assigned activities filtered by the provided search value. Set of returned values is dependent on the current user role. */
  searchContent: Array<AssignedActivity>;
  /** Returns the skill history for a target Learner. */
  skillHistory: Array<ObservationAttempt>;
  /** Returns a list of organizations in the users current collaborative */
  sponsoredOrganizations: Array<Organization>;
  /** Returns a count of all organizations in the users current collaborative */
  sponsoredOrganizationsCount: Scalars['Int']['output'];
  /**
   * Returns a list of all organizations in the Craft System.
   *   This query is only accessible to Craft Admins.
   */
  systemOrganizations: Array<Organization>;
  /**
   * Returns a count of all organizations in the Craft System.
   *   This query is only accessible to Craft Admins.
   */
  systemOrganizationsCount: Scalars['Int']['output'];
  /** Returns the target ratings associated with a given activity. */
  targetRatings: Array<TargetRating>;
  timeTrackedPrograms: Array<TimeTrackedProgram>;
  /** Returns the competency tag with no group assigned which are associated with a given RAP by ID. */
  ungroupedCompetencyTagsByRapId: Array<ContentTag>;
  /** Returns a list of users that have unreachable emails with sendgrid bounced or dropped events */
  unreachableUsers: Array<UserProfile>;
  unreachableUsersCount: Scalars['Int']['output'];
  /** Employer organizations a learner has a role in, used to populate the wage-entry dialog. When `learnerId` is omitted, returns the calling learner's own employers. When supplied by an admin, returns the target learner's employers. Both paths are scoped to the caller's active collaborative and to organizations of type EMPLOYER. */
  wageEntryEmployers: Array<Organization>;
};


export type QueryActivityArgs = {
  activityId: Scalars['ID']['input'];
};


export type QueryActivityReviewByAssignedActivitySubmissionArgs = {
  assignedActivitySubmissionId: Scalars['ID']['input'];
};


export type QueryAdminEdlinkOrganizationsArgs = {
  filterBy?: InputMaybe<OrganizationFilterBy>;
  pagination: PaginationArgs;
};


export type QueryAdminEdlinkOrganizationsCountArgs = {
  filterBy?: InputMaybe<OrganizationFilterBy>;
};


export type QueryAdminSearchUsersArgs = {
  filters?: InputMaybe<AdminUserSearchFilters>;
  pagination: PaginationArgs;
};


export type QueryAdminSearchUsersCountArgs = {
  filters?: InputMaybe<AdminUserSearchFilters>;
};


export type QueryAdminUserEmailChangeHistoryArgs = {
  userId: Scalars['ID']['input'];
};


export type QueryAssignedActivitiesByActivityIdArgs = {
  activityId: Scalars['ID']['input'];
  orderBy?: InputMaybe<Array<AssignedActivitySortOrderBy>>;
  pagination: PaginationArgs;
  search?: InputMaybe<Scalars['String']['input']>;
  tags?: InputMaybe<Array<Scalars['ID']['input']>>;
};


export type QueryAssignedActivitiesByActivityIdCountArgs = {
  activityId: Scalars['ID']['input'];
  search?: InputMaybe<Scalars['String']['input']>;
  tags?: InputMaybe<Array<Scalars['ID']['input']>>;
};


export type QueryAssignedActivitiesPendingApprovalArgs = {
  filters?: InputMaybe<AssignedActivitiesPendingApprovalFilters>;
  orderBy?: InputMaybe<Array<AssignedActivityPendingApprovalSortOrderBy>>;
};


export type QueryAssignedActivitiesWithCompetencyTagArgs = {
  learnerId: Scalars['ID']['input'];
  tagId: Scalars['ID']['input'];
};


export type QueryAssignedActivityArgs = {
  id: Scalars['ID']['input'];
};


export type QueryAssignedLevelArgs = {
  id: Scalars['ID']['input'];
};


export type QueryAssignedLevelsByLevelIdArgs = {
  levelId: Scalars['ID']['input'];
  orderBy?: InputMaybe<Array<AssignedLevelSortOrderBy>>;
  pagination: PaginationArgs;
  search?: InputMaybe<Scalars['String']['input']>;
  tags?: InputMaybe<Array<Scalars['ID']['input']>>;
};


export type QueryAssignedLevelsByLevelIdCountArgs = {
  levelId: Scalars['ID']['input'];
  search?: InputMaybe<Scalars['String']['input']>;
  tags?: InputMaybe<Array<Scalars['ID']['input']>>;
};


export type QueryAssignedPlanArgs = {
  id: Scalars['ID']['input'];
};


export type QueryAssignedPlansByPlanIdArgs = {
  orderBy?: InputMaybe<Array<AssignedPlanSortOrderBy>>;
  pagination: PaginationArgs;
  planId: Scalars['ID']['input'];
  search?: InputMaybe<Scalars['String']['input']>;
  tags?: InputMaybe<Array<Scalars['ID']['input']>>;
};


export type QueryAssignedPlansByPlanIdCountArgs = {
  planId: Scalars['ID']['input'];
  search?: InputMaybe<Scalars['String']['input']>;
  tags?: InputMaybe<Array<Scalars['ID']['input']>>;
};


export type QueryAssignedPlansWithStartedActivitiesArgs = {
  assignedPlanIds: Array<Scalars['ID']['input']>;
};


export type QueryAssignedProgramArgs = {
  id: Scalars['ID']['input'];
};


export type QueryAssignedProgramsByLearnerIdArgs = {
  learnerId: Scalars['ID']['input'];
  orderBy?: InputMaybe<AssignedProgramOrderBy>;
  pagination?: InputMaybe<PaginationArgs>;
};


export type QueryAssignedProgramsByLearnerIdCountArgs = {
  learnerId: Scalars['ID']['input'];
};


export type QueryAssignedProgramsByLearnerIdWithAppliedCompetencyTagArgs = {
  learnerId: Scalars['ID']['input'];
  tagId: Scalars['ID']['input'];
};


export type QueryAssignedProgramsByProgramIdArgs = {
  orderBy?: InputMaybe<Array<AssignedProgramSortOrderBy>>;
  programId: Scalars['ID']['input'];
  search?: InputMaybe<Scalars['String']['input']>;
  skip: Scalars['Int']['input'];
  tags?: InputMaybe<Array<Scalars['ID']['input']>>;
  take: Scalars['Int']['input'];
};


export type QueryAssignedProgramsByProgramIdCountArgs = {
  programId: Scalars['ID']['input'];
  search?: InputMaybe<Scalars['String']['input']>;
  tags?: InputMaybe<Array<Scalars['ID']['input']>>;
};


export type QueryAssignedProgramsWithAbsenceTrackingArgs = {
  learnerId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryAssignedProgramsWithStartedActivitiesArgs = {
  assignedProgramIds: Array<Scalars['ID']['input']>;
};


export type QueryAssignedRapProgramArgs = {
  rapId: Scalars['ID']['input'];
};


export type QueryAssignedRapsByRapIdArgs = {
  filterBy?: InputMaybe<Array<UserFilterBy>>;
  orderBy?: InputMaybe<AssignedRapOrderBy>;
  pagination: PaginationArgs;
  rapId: Scalars['ID']['input'];
  tagFilter?: InputMaybe<Array<Scalars['ID']['input']>>;
};


export type QueryAssignedRapsByRapIdCountArgs = {
  filterBy?: InputMaybe<Array<UserFilterBy>>;
  rapId: Scalars['ID']['input'];
  tagFilter?: InputMaybe<Array<Scalars['ID']['input']>>;
};


export type QueryAvatarArgs = {
  id: Scalars['ID']['input'];
};


export type QueryCollaborativeUsersArgs = {
  excludeSponsorOrgUsers?: InputMaybe<Scalars['Boolean']['input']>;
  filterBy?: InputMaybe<Array<UserFilterBy>>;
  includeDeactivated?: InputMaybe<Scalars['Boolean']['input']>;
  orderBy?: InputMaybe<UserOrderBy>;
  pagination: PaginationArgs;
  tagFilter?: InputMaybe<Array<Scalars['ID']['input']>>;
};


export type QueryCollaborativeUsersCountArgs = {
  excludeSponsorOrgUsers?: InputMaybe<Scalars['Boolean']['input']>;
  filterBy?: InputMaybe<Array<UserFilterBy>>;
  includeDeactivated?: InputMaybe<Scalars['Boolean']['input']>;
  tagFilter?: InputMaybe<Array<Scalars['ID']['input']>>;
};


export type QueryCompetencyTagGroupsByRapIdArgs = {
  filterBy?: InputMaybe<ContentTagGroupFilterBy>;
  orderBy?: InputMaybe<CompetencyTagGroupOrderBy>;
  pagination?: InputMaybe<PaginationArgs>;
  rapId: Scalars['ID']['input'];
};


export type QueryCompetencyTagGroupsByRapIdCountArgs = {
  filterBy?: InputMaybe<ContentTagGroupFilterBy>;
  rapId: Scalars['ID']['input'];
};


export type QueryCompetencyTagsByGroupIdArgs = {
  competencyTagGroupId: Scalars['ID']['input'];
};


export type QueryDraftActivityReviewByAssignedActivityArgs = {
  assignedActivityId: Scalars['ID']['input'];
};


export type QueryExportAbsencesReportArgs = {
  filterBy?: InputMaybe<AbsenceReportFilterBy>;
};


export type QueryGetAbsenceHistoryArgs = {
  programId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryGetAbsenceHistoryForLearnerArgs = {
  learnerId: Scalars['ID']['input'];
  programId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryGetAbsencesReportArgs = {
  filterBy?: InputMaybe<AbsenceReportFilterBy>;
  pagination?: InputMaybe<PaginationArgs>;
  sortBy?: InputMaybe<AbsenceReportSortBy>;
};


export type QueryGetAbsencesReportCountArgs = {
  filterBy?: InputMaybe<AbsenceReportFilterBy>;
};


export type QueryGetCollaborativeOrgsBySponsorOrgArgs = {
  sponsorOrgId: Scalars['ID']['input'];
};


export type QueryGetCredentialEngineCredentialArgs = {
  ctid: Scalars['String']['input'];
};


export type QueryGetEvaluatorsAssignedLearnersArgs = {
  evaluatorId: Scalars['ID']['input'];
  orderBy?: InputMaybe<UserOrderBy>;
  pagination: PaginationArgs;
};


export type QueryGetEvaluatorsAssignedLearnersCountArgs = {
  evaluatorId: Scalars['ID']['input'];
};


export type QueryGetLearnerProfileArgs = {
  learnerId: Scalars['ID']['input'];
};


export type QueryGetLearnersArgs = {
  filterBy?: InputMaybe<Array<UserFilterBy>>;
  learnerIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  orderBy?: InputMaybe<UserOrderBy>;
  pagination?: InputMaybe<PaginationArgs>;
  tagFilter?: InputMaybe<Array<Scalars['ID']['input']>>;
};


export type QueryGetLearnersAssignedEvaluatorsArgs = {
  filterBy?: InputMaybe<Array<UserFilterBy>>;
  learnerId: Scalars['ID']['input'];
  orderBy?: InputMaybe<UserOrderBy>;
  pagination: PaginationArgs;
};


export type QueryGetLearnersAssignedEvaluatorsCountArgs = {
  filterBy?: InputMaybe<Array<UserFilterBy>>;
  learnerId: Scalars['ID']['input'];
};


export type QueryGetLearnersAvailableForAssignmentArgs = {
  filterBy?: InputMaybe<Array<UserFilterBy>>;
  orderBy?: InputMaybe<UserOrderBy>;
  pagination?: InputMaybe<PaginationArgs>;
  programId: Scalars['ID']['input'];
  tagFilter?: InputMaybe<Array<Scalars['ID']['input']>>;
};


export type QueryGetLearnersAvailableForAssignmentCountArgs = {
  filterBy?: InputMaybe<Array<UserFilterBy>>;
  programId: Scalars['ID']['input'];
  tagFilter?: InputMaybe<Array<Scalars['ID']['input']>>;
};


export type QueryGetLearnersCountArgs = {
  filterBy?: InputMaybe<Array<UserFilterBy>>;
  learnerIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  tagFilter?: InputMaybe<Array<Scalars['ID']['input']>>;
};


export type QueryGetLearnersForPlanAssignmentArgs = {
  filterBy?: InputMaybe<Array<UserFilterBy>>;
  orderBy?: InputMaybe<UserOrderBy>;
  pagination?: InputMaybe<PaginationArgs>;
  planId: Scalars['ID']['input'];
  tagFilter?: InputMaybe<Array<Scalars['ID']['input']>>;
};


export type QueryGetLearnersForPlanAssignmentCountArgs = {
  filterBy?: InputMaybe<Array<UserFilterBy>>;
  planId: Scalars['ID']['input'];
  tagFilter?: InputMaybe<Array<Scalars['ID']['input']>>;
};


export type QueryGetLearnersPossibleRelationsByTypeArgs = {
  type: OrganizationType;
};


export type QueryGetProfileArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryLearnerCohortArgs = {
  id: Scalars['ID']['input'];
};


export type QueryLearnerCohortAvailableUsersArgs = {
  filters?: InputMaybe<LearnerCohortUsersFilters>;
  id: Scalars['ID']['input'];
  type: LearnerCohortAssignableUserType;
};


export type QueryLearnerCohortLearnersArgs = {
  filters?: InputMaybe<LearnerCohortUsersFilters>;
  id: Scalars['ID']['input'];
};


export type QueryLearnerCohortUsersArgs = {
  filters?: InputMaybe<LearnerCohortUsersFilters>;
  id: Scalars['ID']['input'];
  type: LearnerCohortAssignableUserType;
};


export type QueryLearnerCohortsArgs = {
  filters?: InputMaybe<LearnerCohortFilters>;
};


export type QueryLearnerWageHistoryArgs = {
  learnerId: Scalars['ID']['input'];
};


export type QueryLearnersWithAssignedActivitiesPendingApprovalArgs = {
  filters?: InputMaybe<LearnersWithAssignedActivitiesPendingApprovalFilters>;
};


export type QueryLevelArgs = {
  levelId: Scalars['ID']['input'];
};


export type QueryLtiAssignedActivityByLearnerEmailAndActivityIdArgs = {
  activityId: Scalars['ID']['input'];
  learnerEmail: Scalars['String']['input'];
};


export type QueryMetabaseIframeUrlArgs = {
  metabaseDashboardId: Scalars['Int']['input'];
  reportId?: InputMaybe<Scalars['String']['input']>;
  reportParams?: InputMaybe<Scalars['String']['input']>;
};


export type QueryMetabaseIframeUrlByLearnerIdArgs = {
  learnerId?: InputMaybe<Scalars['String']['input']>;
  metabaseDashboardId: Scalars['Int']['input'];
  reportId?: InputMaybe<Scalars['String']['input']>;
};


export type QueryMyAbsencesArgs = {
  programId: Scalars['ID']['input'];
};


export type QueryOccupationsArgs = {
  filters?: InputMaybe<OccupationsFilters>;
  limit?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryOrganizationEvaluatorsArgs = {
  where: OrganizationEvaluatorsInput;
};


export type QueryOrganizationProgramsArgs = {
  filterOutRapPrograms?: InputMaybe<Scalars['Boolean']['input']>;
  returnOnlyRapPrograms?: InputMaybe<Scalars['Boolean']['input']>;
  state?: InputMaybe<ProgramState>;
};


export type QueryOrganizationProgramsWithAppliedCompetencyTagArgs = {
  tagId: Scalars['ID']['input'];
};


export type QueryOrganizationTagsArgs = {
  organizationId: Scalars['ID']['input'];
};


export type QueryOrganizationUsersArgs = {
  filterBy?: InputMaybe<Array<UserFilterBy>>;
  includeDeactivated?: InputMaybe<Scalars['Boolean']['input']>;
  orderBy?: InputMaybe<UserOrderBy>;
  pagination: PaginationArgs;
  tagFilter?: InputMaybe<Array<Scalars['ID']['input']>>;
};


export type QueryOrganizationUsersCountArgs = {
  filterBy?: InputMaybe<Array<UserFilterBy>>;
  includeDeactivated?: InputMaybe<Scalars['Boolean']['input']>;
  tagFilter?: InputMaybe<Array<Scalars['ID']['input']>>;
};


export type QueryOtherCollaborativeOrgAssignedProgramsByLearnerIdWithAppliedCompetencyTagArgs = {
  learnerId: Scalars['ID']['input'];
  tagId: Scalars['ID']['input'];
};


export type QueryOtherCollaborativeOrgProgramsWithAppliedCompetencyTagArgs = {
  tagId: Scalars['ID']['input'];
};


export type QueryPendingObservationAttemptArgs = {
  id: Scalars['ID']['input'];
};


export type QueryPendingObservationAttemptsArgs = {
  filters?: InputMaybe<PendingObservationAttemptsFilters>;
  orderBy?: InputMaybe<PendingObservationAttemptSortOrderBy>;
};


export type QueryPendingObservationAttemptsLearnersArgs = {
  filters?: InputMaybe<PendingObservationAttemptsLearnersFilters>;
};


export type QueryPendingProgramTimeEntriesArgs = {
  filters?: InputMaybe<PendingProgramTimeEntriesFilters>;
  orderBy?: InputMaybe<PendingTimeEntrySortOrderBy>;
};


export type QueryPendingProgramTimeEntriesLearnersArgs = {
  filters?: InputMaybe<PendingTimeEntriesLearnersFilters>;
};


export type QueryPlanArgs = {
  planId: Scalars['ID']['input'];
};


export type QueryPlansAssignedToInstructorArgs = {
  instructorId: Scalars['ID']['input'];
  orderBy?: InputMaybe<PlanOrderBy>;
  pagination?: InputMaybe<PaginationArgs>;
};


export type QueryPlansAssignedToInstructorCountArgs = {
  instructorId: Scalars['ID']['input'];
};


export type QueryProgramArgs = {
  programId: Scalars['ID']['input'];
};


export type QueryProgramAssignedLearnersArgs = {
  programId: Scalars['ID']['input'];
};


export type QueryProgramProgressArgs = {
  assignedProgramId: Scalars['ID']['input'];
};


export type QueryProgramProgressAggregateArgs = {
  assignedProgramId: Scalars['ID']['input'];
};


export type QueryProgramTimeEntriesArgs = {
  programId: Scalars['ID']['input'];
  relatedUserId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryProgramTimeEntryArgs = {
  dateKey: Scalars['DateKey']['input'];
  programId: Scalars['ID']['input'];
  relatedUserId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryProgramTimeEntryByIdArgs = {
  entryId: Scalars['ID']['input'];
};


export type QueryRapArgs = {
  rapId: Scalars['ID']['input'];
};


export type QueryRubricByIdArgs = {
  assignedActivityId?: InputMaybe<Scalars['ID']['input']>;
  rubricId: Scalars['ID']['input'];
};


export type QueryRubricsArgs = {
  filters?: InputMaybe<RubricFilters>;
  pagination?: InputMaybe<PaginationArgs>;
};


export type QuerySearchContentArgs = {
  searchValue: Scalars['String']['input'];
};


export type QuerySkillHistoryArgs = {
  learnerId?: InputMaybe<Scalars['ID']['input']>;
  skillId: Scalars['ID']['input'];
};


export type QuerySponsoredOrganizationsArgs = {
  excludeSponsorOrg?: InputMaybe<Scalars['Boolean']['input']>;
  filterBy?: InputMaybe<OrganizationFilterBy>;
  orderBy?: InputMaybe<OrganizationOrderBy>;
  pagination?: InputMaybe<PaginationArgs>;
};


export type QuerySponsoredOrganizationsCountArgs = {
  excludeSponsorOrg?: InputMaybe<Scalars['Boolean']['input']>;
  filterBy?: InputMaybe<OrganizationFilterBy>;
};


export type QuerySystemOrganizationsArgs = {
  filterBy?: InputMaybe<OrganizationFilterBy>;
  orderBy?: InputMaybe<OrganizationOrderBy>;
  pagination?: InputMaybe<PaginationArgs>;
};


export type QuerySystemOrganizationsCountArgs = {
  filterBy?: InputMaybe<OrganizationFilterBy>;
};


export type QueryTargetRatingsArgs = {
  activityId: Scalars['ID']['input'];
  rubricId: Scalars['ID']['input'];
};


export type QueryTimeTrackedProgramsArgs = {
  relatedUserId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryUngroupedCompetencyTagsByRapIdArgs = {
  rapId: Scalars['ID']['input'];
};


export type QueryUnreachableUsersArgs = {
  filterBy?: InputMaybe<Array<UserFilterBy>>;
  includeDeactivated?: InputMaybe<Scalars['Boolean']['input']>;
  orderBy?: InputMaybe<UserOrderBy>;
  pagination: PaginationArgs;
  tagFilter?: InputMaybe<Array<Scalars['ID']['input']>>;
};


export type QueryUnreachableUsersCountArgs = {
  filterBy?: InputMaybe<Array<UserFilterBy>>;
};


export type QueryWageEntryEmployersArgs = {
  learnerId?: InputMaybe<Scalars['ID']['input']>;
};

export type RapDateInput = {
  anticipatedEndDate: Scalars['DateTime']['input'];
  startDate: Scalars['DateTime']['input'];
};

/** A rating for a criterion. A criterion can have multiple ratings. Ratings could have an optional score. */
export type Rating = {
  __typename?: 'Rating';
  criterion: Criterion;
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  label: Scalars['String']['output'];
  order: Scalars['Float']['output'];
  score?: Maybe<Scalars['Float']['output']>;
};

export type RatingInput = {
  description?: InputMaybe<Scalars['NonEmptyString']['input']>;
  label: Scalars['NonEmptyString']['input'];
  score?: InputMaybe<Scalars['Int']['input']>;
};

/** The position of the new rating in the list. */
export enum RatingPosition {
  Left = 'LEFT',
  Right = 'RIGHT'
}

export type ReassignLearnersToProgramInput = {
  anticipatedEndDate: Scalars['DateTime']['input'];
  startDate: Scalars['DateTime']['input'];
};

export type RecordWageEntryInput = {
  amount: Scalars['Decimal']['input'];
  effectiveDate: Scalars['DateTime']['input'];
  employerId: Scalars['ID']['input'];
  learnerId: Scalars['ID']['input'];
  programId: Scalars['ID']['input'];
  rateUnit: WageRateUnit;
  reason?: InputMaybe<Scalars['String']['input']>;
};

export type RegisteredApprenticeshipProgram = {
  __typename?: 'RegisteredApprenticeshipProgram';
  collaborativeId: Scalars['String']['output'];
  /** The groups of competency tags associated with this RAP. */
  competencyTagGroups: Array<ContentTagGroup>;
  /** The competency tags associated with this RAP. */
  competencyTags: Array<ContentTag>;
  description?: Maybe<Scalars['String']['output']>;
  displayOrder: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  isPublished: Scalars['Boolean']['output'];
  /** The learners available to assign to this RAP. */
  learnersAvailableToAssign: Array<LearnerProfile>;
  learnersAvailableToAssignCount: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  program?: Maybe<Program>;
  rapidsId?: Maybe<Scalars['String']['output']>;
  /** Sponsor of this RAP. A RAP should have exactly 1 sponsor. */
  sponsor: Organization;
  /** The competency tags associated with this RAP which are not part of a group. */
  ungroupedCompetencyTags: Array<ContentTag>;
};


export type RegisteredApprenticeshipProgramLearnersAvailableToAssignArgs = {
  filterBy?: InputMaybe<Array<UserFilterBy>>;
  orderBy?: InputMaybe<UserOrderBy>;
  pagination: PaginationArgs;
  tagFilter?: InputMaybe<Array<Scalars['ID']['input']>>;
};


export type RegisteredApprenticeshipProgramLearnersAvailableToAssignCountArgs = {
  filterBy?: InputMaybe<Array<UserFilterBy>>;
  tagFilter?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type Removal = {
  id: Scalars['ID']['input'];
};

export type RemoveActivityRequirementInput = {
  activityId: Scalars['ID']['input'];
  requiredArtifact: RequiredActivityArtifact;
  requirementAppliesTo: RequirementAppliesTo;
};

export type RemoveProgramTimeItemInput = {
  id: Scalars['ID']['input'];
};

export type RenameTagInput = {
  newValue: Scalars['NonEmptyString']['input'];
};

export type RequestEvaluationCustomFieldData = {
  id: Scalars['ID']['input'];
  value: Scalars['String']['input'];
};

export type RequestEvaluationData = {
  customFieldValues?: InputMaybe<Array<RequestEvaluationCustomFieldData>>;
  evaluatorId: Scalars['ID']['input'];
  learnerNotes?: InputMaybe<Scalars['StandardOptionalUserInputString']['input']>;
  performedAt: Scalars['DateTime']['input'];
  skillIds: Array<Scalars['ID']['input']>;
};

export enum RequiredActivityArtifact {
  Comment = 'COMMENT',
  Duration = 'DURATION',
  File = 'FILE',
  FileOrLink = 'FILE_OR_LINK',
  Link = 'LINK',
  ObservationDate = 'OBSERVATION_DATE',
  Score = 'SCORE'
}

export enum RequirementAppliesTo {
  EvaluatingUser = 'EVALUATING_USER',
  Learner = 'LEARNER'
}

export type ReturnTimeEntryInput = {
  comment: Scalars['TrimmedNonEmptyString']['input'];
};

/**
 * A rubric for an activity. An activity can have multiple rubrics.
 *   Rubrics are made of criteria.
 */
export type Rubric = {
  __typename?: 'Rubric';
  activities: Array<Activity>;
  /** Determine if an activity has been scored with this rubric. */
  activitiesScoredWithThisRubric: Scalars['Boolean']['output'];
  criteria: Array<Criterion>;
  description?: Maybe<Scalars['String']['output']>;
  externalId?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  naRatingEnabled: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  numericRatingEnabled: Scalars['Boolean']['output'];
  state: RubricState;
};

/** Filters that can be used for querying rubrics. */
export type RubricFilters = {
  /** A search term to filter rubrics by. */
  search?: InputMaybe<StringFilter>;
  /** An array of rubric states to filter by. */
  state: Array<RubricState>;
};

export type RubricNameOrDescriptionInput = {
  description?: InputMaybe<Scalars['NonEmptyString']['input']>;
  name?: InputMaybe<Scalars['NonEmptyString']['input']>;
};

export enum RubricState {
  Archived = 'ARCHIVED',
  Draft = 'DRAFT',
  Published = 'PUBLISHED'
}

export type SaveAssignedActivityCommentData = {
  assignedActivityId: Scalars['ID']['input'];
  comment: Scalars['String']['input'];
};

export type SaveObservationDateData = {
  assignedActivityId: Scalars['ID']['input'];
  observedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type ScoreObservationAttemptInput = {
  observerComment?: InputMaybe<Scalars['StandardOptionalUserInputString']['input']>;
  score: ObservationAttemptScore;
};

/** Single entry to represent a rating and its corresponding optional comment. */
export type ScoredCriterion = {
  __typename?: 'ScoredCriterion';
  activityReview: ActivityReview;
  activityReviewId: Scalars['String']['output'];
  comment?: Maybe<Scalars['String']['output']>;
  criterion: Criterion;
  criterionId: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  selectedRating?: Maybe<Rating>;
  selectedRatingId?: Maybe<Scalars['String']['output']>;
};

export type ScoredCriterionInput = {
  comment?: InputMaybe<Scalars['String']['input']>;
  selectedRatingId?: InputMaybe<Scalars['ID']['input']>;
};

export type ScoredObservationAttempt = ScoredObservationAttemptInterface & {
  __typename?: 'ScoredObservationAttempt';
  createdAt: Scalars['DateTime']['output'];
  customFieldValues: Array<ObservationCustomFieldValue>;
  id: Scalars['ID']['output'];
  isCompetent: Scalars['Boolean']['output'];
  learner: UserProfile;
  learnerNotes?: Maybe<Scalars['SanitizedString']['output']>;
  observer: UserProfile;
  observerComment?: Maybe<Scalars['String']['output']>;
  performedAt: Scalars['DateTime']['output'];
  score: ObservationAttemptScoreModel;
  scoredAt: Scalars['DateTime']['output'];
  skill: LearnerObservationSkill;
  updatedAt: Scalars['DateTime']['output'];
};

export type ScoredObservationAttemptInterface = {
  createdAt: Scalars['DateTime']['output'];
  customFieldValues: Array<ObservationCustomFieldValue>;
  id: Scalars['ID']['output'];
  learner: UserProfile;
  learnerNotes?: Maybe<Scalars['SanitizedString']['output']>;
  observer: UserProfile;
  performedAt: Scalars['DateTime']['output'];
  skill: LearnerObservationSkill;
  updatedAt: Scalars['DateTime']['output'];
};

/** Select an organization role for an app user. The data model allows us to select a null organization role, but we do not currently need to do that. Hence the organizationRoleId is non-null. */
export type SelectOrganizationRoleForAppUserInput = {
  organizationRoleId: Scalars['ID']['input'];
};

/** Data to change the unlock date of an assigned level. */
export type SetAssignedLevelUnlockedOnData = {
  unlockOn: Scalars['DateTime']['input'];
};

/** Data to set the due date on an activity. */
export type SetDueDateOnActivityData = {
  dueDate: Scalars['DateTime']['input'];
};

export type SetLevelLockSettingInput = {
  newLockSetting: Scalars['Boolean']['input'];
};

export type SetRubricNaRatingConfigurationInput = {
  enabled: Scalars['Boolean']['input'];
};

export type SetRubricNumericScoresConfigurationInput = {
  enabled: Scalars['Boolean']['input'];
};

export type SkillInterface = {
  configuration: ProgramObservationTracking;
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  learnerId?: Maybe<Scalars['ID']['output']>;
  minimumSuccessfulAttempts?: Maybe<Scalars['MinimumSuccessfulAttempts']['output']>;
  name: Scalars['LongUserInputString']['output'];
  program: Program;
  repeatable: Scalars['Boolean']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export enum SortOrder {
  Asc = 'asc',
  Desc = 'desc'
}

export type StringFilter = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equals?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<Scalars['String']['input']>>;
  mode?: InputMaybe<StringFilterMode>;
  not?: InputMaybe<StringFilter>;
  notIn?: InputMaybe<Array<Scalars['String']['input']>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};

export enum StringFilterMode {
  Default = 'DEFAULT',
  Insensitive = 'INSENSITIVE'
}

export type SubmitScoredObservationAttemptScore = {
  observerComment?: InputMaybe<Scalars['StandardOptionalUserInputString']['input']>;
  score: ObservationAttemptScore;
  skillId: Scalars['ID']['input'];
};

export type SubmitScoredObservationAttemptsData = {
  customFieldValues?: InputMaybe<Array<RequestEvaluationCustomFieldData>>;
  performedAt: Scalars['DateTime']['input'];
  scores: Array<SubmitScoredObservationAttemptScore>;
};

export type SubmitTimeEntryInput = {
  /** Whether or not the time entry should be immediately approved after it is submitted. */
  approveAfterSubmission?: InputMaybe<Scalars['Boolean']['input']>;
  comment?: InputMaybe<Scalars['SanitizedString']['input']>;
  dateKey: Scalars['DateKey']['input'];
  items: Array<TimeEntryItemInput>;
  /** IDs of the evaluators the learner has selected to review this submission. Omit or pass empty for route-to-all behavior. */
  reviewerIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type SubmitWageEntryInput = {
  amount: Scalars['Decimal']['input'];
  effectiveDate: Scalars['DateTime']['input'];
  employerId: Scalars['ID']['input'];
  programId: Scalars['ID']['input'];
  rateUnit: WageRateUnit;
  reason?: InputMaybe<Scalars['String']['input']>;
};

export type TagUserInput = {
  tags: Array<CreateTagInput>;
  userId: Scalars['ID']['input'];
};

/** The target rating for a given criterion in an activity review. */
export type TargetRating = {
  __typename?: 'TargetRating';
  activity: Activity;
  criterion: Criterion;
  direction: TargetRatingDirection;
  id: Scalars['ID']['output'];
  rating: Rating;
};

export enum TargetRatingDirection {
  Left = 'LEFT',
  Right = 'RIGHT'
}

export type TimeEntryItemInput = {
  itemId: Scalars['ID']['input'];
  minutes?: InputMaybe<Scalars['PositiveInteger']['input']>;
};

export enum TimeEntryReviewState {
  Approved = 'APPROVED',
  Returned = 'RETURNED',
  Submitted = 'SUBMITTED'
}

export enum TimeSchedule {
  Daily = 'DAILY',
  Monthly = 'MONTHLY'
}

/** Time spent on a task. A breakdown of the total time spent on any given task */
export type TimeSpent = {
  __typename?: 'TimeSpent';
  hours: Scalars['Int']['output'];
  minutes: Scalars['Int']['output'];
  totalTime: Scalars['Int']['output'];
};

export type TimeTrackedProgram = {
  __typename?: 'TimeTrackedProgram';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  timeSchedule: TimeSchedule;
};

export type TrackedTimeItemLoggedMinutes = {
  __typename?: 'TrackedTimeItemLoggedMinutes';
  /** The number of minutes logged for time entries whose most recent review is in an approved state. */
  approved: Scalars['Int']['output'];
  /** The ID of the time item associated with these metrics. */
  itemId: Scalars['ID']['output'];
  /** The ratio of minutes that the learner has logged for this time item across all time entries relative to the target hours for the time item.  If the total number of logged minutes exceeds the target, the ratio will be capped at 1. */
  loggedRatio: Scalars['Float']['output'];
  /** The ratios of minutes that the learner has logged for time entries in each state relative to the target hours for the time item. If the total logged minutes exceeds the target hours, the ratios will be normalized such that the sum of the ratios does not exceed 1. */
  loggedRatios: TrackedTimeItemStateRatios;
  /** Represents the logged minutes for this time item across all time entries indexed by the state of the most recent review for each time entry, normalized such that the sum of the logged minutes for each state does not exceed the target minutes for the time item. */
  normalized?: Maybe<TrackedTimeItemStateMetrics>;
  /** The number of minutes logged for time entries whose most recent review is in a submitted state. */
  pending: Scalars['Int']['output'];
  /** The number of minutes logged for time entries whose most recent review is in a returned state. */
  returned: Scalars['Int']['output'];
  /** The total number of minutes logged for this time item across all time entries. */
  total: Scalars['Int']['output'];
  /** The number of minutes logged for time entries whose most recent review is not in an approved state. */
  unapproved: Scalars['Int']['output'];
};

/** Represents the number of logged minutes for a specific time item across all entries, indexed by the state of the time entries that the minutes were logged for. */
export type TrackedTimeItemStateMetrics = {
  __typename?: 'TrackedTimeItemStateMetrics';
  /** The number of minutes logged for time entries whose most recent review is in an approved state. */
  approved: Scalars['Int']['output'];
  /** The number of minutes logged for time entries whose most recent review is in a submitted state. */
  pending: Scalars['Int']['output'];
  /** The number of minutes logged for time entries whose most recent review is in a returned state. */
  returned: Scalars['Int']['output'];
  /** The number of minutes logged for time entries whose most recent review is not in an approved state. */
  unapproved: Scalars['Int']['output'];
};

/** Represents the number of logged minutes for a specific time item across all time entriesexpressed as ratios of the total logged minutes for that item, indexed by the state of the time entries that the minutes were logged for. */
export type TrackedTimeItemStateRatios = {
  __typename?: 'TrackedTimeItemStateRatios';
  approved: Scalars['Float']['output'];
  pending: Scalars['Float']['output'];
  returned: Scalars['Float']['output'];
  unapproved: Scalars['Float']['output'];
};

export type UnScoredObservationAttempt = UnScoredObservationAttemptInterface & {
  __typename?: 'UnScoredObservationAttempt';
  createdAt: Scalars['DateTime']['output'];
  customFieldValues: Array<ObservationCustomFieldValue>;
  id: Scalars['ID']['output'];
  learner: UserProfile;
  learnerNotes?: Maybe<Scalars['SanitizedString']['output']>;
  observer: UserProfile;
  performedAt: Scalars['DateTime']['output'];
  skill: LearnerObservationSkill;
  updatedAt: Scalars['DateTime']['output'];
};

export type UnScoredObservationAttemptInterface = {
  createdAt: Scalars['DateTime']['output'];
  customFieldValues: Array<ObservationCustomFieldValue>;
  id: Scalars['ID']['output'];
  learner: UserProfile;
  learnerNotes?: Maybe<Scalars['SanitizedString']['output']>;
  observer: UserProfile;
  performedAt: Scalars['DateTime']['output'];
  skill: LearnerObservationSkill;
  updatedAt: Scalars['DateTime']['output'];
};

export type UntagUserInput = {
  tagIds: Array<Scalars['ID']['input']>;
  userId: Scalars['ID']['input'];
};

export type UpdateAbsenceInput = {
  /** Optional comment. Required when reason is OTHER. */
  comment?: InputMaybe<Scalars['String']['input']>;
  /** Date of the absence */
  date: Scalars['DateTime']['input'];
  /** Duration of the absence */
  duration: AbsenceDuration;
  /** ID of the absence to update */
  id: Scalars['ID']['input'];
  /** Program ID for the absence */
  programId: Scalars['ID']['input'];
  /** Reason for the absence */
  reason?: InputMaybe<AbsenceReason>;
};

export type UpdateActivityDescriptionInput = {
  description?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateActivityExternalIdInput = {
  activityId: Scalars['ID']['input'];
  externalId?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateActivityNameInput = {
  activityId: Scalars['ID']['input'];
  name: Scalars['NonEmptyString']['input'];
};

export type UpdateActivityOrderInput = {
  activityIds: Array<Scalars['ID']['input']>;
};

export type UpdateActivityTargetRatingsInput = {
  criterionId: Scalars['ID']['input'];
  /** The new target rating direction. */
  direction: TargetRatingDirection;
  ratingId: Scalars['ID']['input'];
};

export type UpdateAddressInput = {
  addressLine1?: InputMaybe<Scalars['NonEmptyString']['input']>;
  addressLine2?: InputMaybe<Scalars['NonEmptyString']['input']>;
  city?: InputMaybe<Scalars['NonEmptyString']['input']>;
  state?: InputMaybe<Scalars['NonEmptyString']['input']>;
  zipCode?: InputMaybe<Scalars['NonEmptyString']['input']>;
};

/** Data that is used to update the time spent of an assigned activity. */
export type UpdateAssignedActivityTimeSpentData = {
  hours: Scalars['Int']['input'];
  minutes: Scalars['Int']['input'];
};

export type UpdateAssignedProgramDatesInput = {
  anticipatedEndDate: Scalars['DateTime']['input'];
  startDate: Scalars['DateTime']['input'];
};

export type UpdateAssignedProgramsDateRangeInput = {
  anticipatedEndDate: Scalars['DateTime']['input'];
  startDate: Scalars['DateTime']['input'];
};

export type UpdateCompetencyTagData = {
  displayValue: Scalars['String']['input'];
  groupId?: InputMaybe<Scalars['String']['input']>;
  newGroupName?: InputMaybe<Scalars['String']['input']>;
  value: Scalars['String']['input'];
};

export type UpdateExternalIdInput = {
  externalId?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateFundingEntryInput = {
  amount?: InputMaybe<Scalars['Decimal']['input']>;
  customFundingSource?: InputMaybe<Scalars['String']['input']>;
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  fundingSource?: InputMaybe<FundingSource>;
  id: Scalars['ID']['input'];
  notes?: InputMaybe<Scalars['String']['input']>;
  programId?: InputMaybe<Scalars['ID']['input']>;
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
};

export type UpdateLearnerCohortData = {
  description?: InputMaybe<Scalars['String']['input']>;
  /** The end date of the cohort. */
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  /** The start date of the cohort. */
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
  /** The state of the learner cohort. */
  state?: InputMaybe<LearnerCohortState>;
};

export type UpdateLearnerCohortsData = {
  /** The state of the learner cohort. */
  state?: InputMaybe<LearnerCohortState>;
};

export type UpdateLevelDescriptionInput = {
  description?: InputMaybe<Scalars['NonEmptyString']['input']>;
  levelId: Scalars['ID']['input'];
};

export type UpdateLevelExternalIdInput = {
  externalId?: InputMaybe<Scalars['String']['input']>;
  levelId: Scalars['ID']['input'];
};

export type UpdateLevelNameInput = {
  levelId: Scalars['ID']['input'];
  name: Scalars['NonEmptyString']['input'];
};

export type UpdateLevelOrderInput = {
  levelIds: Array<Scalars['ID']['input']>;
};

export type UpdateObservationTrackingInput = {
  categories?: InputMaybe<ObservationCategoryChanges>;
  customFields?: InputMaybe<ObservationCustomFieldChanges>;
  customLabels?: InputMaybe<Array<InputMaybe<Scalars['StandardOptionalUserInputString']['input']>>>;
  isPreApprovalEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  scoringMethod?: InputMaybe<ObservationScoringMethod>;
  skills?: InputMaybe<ObservationSkillChanges>;
  targetScore?: InputMaybe<Scalars['TargetScore']['input']>;
};

export type UpdateOrganizationNameInput = {
  name: Scalars['NonEmptyString']['input'];
  organizationId: Scalars['ID']['input'];
};

export type UpdateOrganizationRoleClearedStatusInput = {
  clearedStatus?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UpdateOrganizationSupportContactInput = {
  email: Scalars['NonEmptyString']['input'];
  id: Scalars['ID']['input'];
  title?: InputMaybe<Scalars['NonEmptyString']['input']>;
};

export type UpdatePlanDescriptionInput = {
  description?: InputMaybe<Scalars['NonEmptyString']['input']>;
  planId: Scalars['ID']['input'];
};

export type UpdatePlanExternalIdInput = {
  externalId?: InputMaybe<Scalars['String']['input']>;
  planId: Scalars['ID']['input'];
};

export type UpdatePlanNameInput = {
  name: Scalars['NonEmptyString']['input'];
  planId: Scalars['ID']['input'];
};

export type UpdatePlanOrderInput = {
  planIds: Array<Scalars['ID']['input']>;
};

export type UpdateProgramAbsenceTrackingEnabledInput = {
  absenceTrackingEnabled: Scalars['Boolean']['input'];
  programId: Scalars['ID']['input'];
};

export type UpdateProgramCourseworkEnabledInput = {
  courseworkEnabled: Scalars['Boolean']['input'];
  programId: Scalars['ID']['input'];
};

export type UpdateProgramDescriptionInput = {
  description?: InputMaybe<Scalars['NonEmptyString']['input']>;
  programId: Scalars['ID']['input'];
};

export type UpdateProgramExternalIdInput = {
  externalId?: InputMaybe<Scalars['String']['input']>;
  programId: Scalars['ID']['input'];
};

export type UpdateProgramInput = {
  industry?: InputMaybe<IndustryId>;
  occupationId?: InputMaybe<Scalars['ID']['input']>;
};

export type UpdateProgramNameInput = {
  name: Scalars['NonEmptyString']['input'];
  programId: Scalars['ID']['input'];
};

export type UpdateProgramOrderInput = {
  programIds: Array<Scalars['ID']['input']>;
};

export type UpdateProgramStateInput = {
  programId: Scalars['ID']['input'];
  programState: ProgramState;
};

export type UpdateProgramTimeItemInput = {
  id: Scalars['ID']['input'];
  name?: InputMaybe<Scalars['ProgramTimeItemName']['input']>;
  target?: InputMaybe<Scalars['PositiveInteger']['input']>;
};

export type UpdateProgramTimeTrackingInput = {
  /** The time items to be added, updated, or removed from the program. */
  items?: InputMaybe<UpdateProgramTimeTrackingItemsInput>;
  schedule?: InputMaybe<TimeSchedule>;
};

export type UpdateProgramTimeTrackingItemsInput = {
  /** The time items that should be added to the program. */
  add?: InputMaybe<Array<ProgramTimeItemInput>>;
  /** The time items that should be removed from the program. */
  remove?: InputMaybe<Array<RemoveProgramTimeItemInput>>;
  /** The time items that should be updated in the program. */
  update?: InputMaybe<Array<UpdateProgramTimeItemInput>>;
};

export type UpdateRapInput = {
  description?: InputMaybe<Scalars['NonEmptyString']['input']>;
  name?: InputMaybe<Scalars['NonEmptyString']['input']>;
  rapidsId?: InputMaybe<Scalars['rapidsId']['input']>;
};

export type UpdateRapOrderInput = {
  rapIds: Array<Scalars['ID']['input']>;
};

export type UpdateUserInput = {
  address?: InputMaybe<UpdateAddressInput>;
  dateOfBirth?: InputMaybe<Scalars['DateOfBirth']['input']>;
  email?: InputMaybe<Scalars['EmailAddress']['input']>;
  firstName?: InputMaybe<Scalars['NonEmptyString']['input']>;
  hasNoAddress?: InputMaybe<Scalars['Boolean']['input']>;
  hasNoPhoneNumber?: InputMaybe<Scalars['Boolean']['input']>;
  lastName?: InputMaybe<Scalars['NonEmptyString']['input']>;
  middleName?: InputMaybe<Scalars['NonEmptyString']['input']>;
  phoneNumber?: InputMaybe<Scalars['NonEmptyString']['input']>;
};

export type UpdateWageEntryInput = {
  amount?: InputMaybe<Scalars['Decimal']['input']>;
  effectiveDate?: InputMaybe<Scalars['DateTime']['input']>;
  employerId?: InputMaybe<Scalars['ID']['input']>;
  id: Scalars['ID']['input'];
  programId?: InputMaybe<Scalars['ID']['input']>;
  rateUnit?: InputMaybe<WageRateUnit>;
  reason?: InputMaybe<Scalars['String']['input']>;
};

export type UserFilterBy = {
  email?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  role?: InputMaybe<Scalars['String']['input']>;
};

export type UserOrderBy = {
  createdAt?: InputMaybe<SortOrder>;
  email?: InputMaybe<SortOrder>;
  firstName?: InputMaybe<SortOrder>;
  inactive?: InputMaybe<SortOrder>;
  invitedAt?: InputMaybe<SortOrder>;
  lastName?: InputMaybe<SortOrder>;
  lastSignIn?: InputMaybe<SortOrder>;
};

export type UserProfile = {
  __typename?: 'UserProfile';
  /** Physical address for the user. */
  address?: Maybe<Address>;
  /** All emails associated with the user. Only for use by the user themselves */
  allEmails: Array<AppUserEmail>;
  /** The user's avatar, resolved server-side from their Gravatar. */
  avatar: Avatar;
  /** Whether the calling viewer may add a funding entry for this learner. Driven server-side from the same owner-or-related-admin rule the `createFundingEntry` mutation enforces so the frontend can show or hide the add affordance without reproducing the logic. */
  canRecordFundingEntry: Scalars['Boolean']['output'];
  /** Date the user record was created */
  createdAt: Scalars['DateTime']['output'];
  /** The user's date of birth. */
  dateOfBirth?: Maybe<Scalars['DateTime']['output']>;
  /** The user's email address for the current organization. */
  email: Scalars['String']['output'];
  /** User email status from sendgrid */
  emailStatus: EmailStatus;
  /** External ID for this user in this organization. */
  externalId?: Maybe<Scalars['String']['output']>;
  /** User's first name */
  firstName: Scalars['String']['output'];
  /** User's full name */
  fullName: Scalars['String']['output'];
  /** The learner's funding entries, most-recent start date first. Authorized at the field level: the learner sees their own, a related funding-capable admin sees the learner's; any other viewer of the profile (e.g. instructor, facilitator) receives an empty list. */
  fundingEntries: Array<LearnerFundingEntry>;
  /** Defines whether or not the user is missing required information from their profile. */
  hasCompleteProfile: Scalars['Boolean']['output'];
  /** Indicates if the user has no address. */
  hasNoAddress: Scalars['Boolean']['output'];
  /** Indicates if the user has no phone number. */
  hasNoPhoneNumber: Scalars['Boolean']['output'];
  /** User's UUID */
  id: Scalars['String']['output'];
  /** User is inactive. */
  inactive: Scalars['Boolean']['output'];
  /** User first and last name initials. */
  initials: Scalars['String']['output'];
  /** The last time this user was invited. */
  invitedAt?: Maybe<Scalars['DateTime']['output']>;
  /** User's last name */
  lastName: Scalars['String']['output'];
  /** The last time this user was invited. */
  lastSignIn?: Maybe<Scalars['DateTime']['output']>;
  /** User's full name, including their middle name. */
  longName: Scalars['String']['output'];
  /** User's middleName name */
  middleName?: Maybe<Scalars['String']['output']>;
  /** User roles in organizations. */
  organizationRoles: Array<OrganizationRole>;
  /** User's phone number */
  phoneNumber?: Maybe<AppUserPhoneNumber>;
  /** The user's primary email addressed. Only for use by the user themselves */
  primaryEmail?: Maybe<AppUserEmail>;
  /** User selected organization role. */
  selectedOrganizationRole?: Maybe<OrganizationRole>;
  /** Tags assigned to the user. The list is filtered by the requesting user's organization. */
  tags: Array<UserTag>;
};


export type UserProfileFundingEntriesArgs = {
  pagination?: InputMaybe<PaginationArgs>;
};

/** A tag that can be applied to a user. */
export type UserTag = {
  __typename?: 'UserTag';
  id: Scalars['ID']['output'];
  organizationId: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export type UserWhereInput = {
  AND?: InputMaybe<Array<UserWhereInput>>;
  NOT?: InputMaybe<Array<UserWhereInput>>;
  OR?: InputMaybe<Array<UserWhereInput>>;
  assignedPrograms?: InputMaybe<AssignedProgramFilter>;
  email?: InputMaybe<StringFilter>;
  firstName?: InputMaybe<StringFilter>;
  id?: InputMaybe<StringFilter>;
  lastName?: InputMaybe<StringFilter>;
  organizationRoles?: InputMaybe<OrganizationRoleFilter>;
};

export enum WageRateUnit {
  Daily = 'DAILY',
  Hourly = 'HOURLY',
  Weekly = 'WEEKLY',
  Yearly = 'YEARLY'
}

export enum WageReporter {
  Admin = 'ADMIN',
  Learner = 'LEARNER'
}
